/**
 * Base SDK error.
 *
 * The code is stable enough for simple checks in user code.
 */ class $b09ac485321cc4ed$export$bd5e1fd04abe33dd extends Error {
    code;
    constructor(code, message){
        super(message);
        this.name = new.target.name;
        this.code = code;
    }
}
class $b09ac485321cc4ed$export$f2e832acab1bdd79 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$9f48ca187ff38621 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$f91b299ee183332c extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("build_error", message);
    }
}
class $b09ac485321cc4ed$export$107365fdc90b0143 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("publish_error", message);
    }
}
class $b09ac485321cc4ed$export$8e68de6fb26f2236 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$d8ea20af4c01b9d9 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(code, message){
        super(code, message);
    }
}
class $b09ac485321cc4ed$export$fe40046a1b08a9d7 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("meta_encode_error", message);
    }
}
class $b09ac485321cc4ed$export$6d29b48d1471e7e6 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("meta_decode_error", message);
    }
}
class $b09ac485321cc4ed$export$d5d995a9f97288b3 extends $b09ac485321cc4ed$export$bd5e1fd04abe33dd {
    constructor(message){
        super("state_sync_error", message);
    }
}


const $2a6bed64870680d8$var$textEncoder = new TextEncoder();
const $2a6bed64870680d8$var$textDecoder = new TextDecoder();
function $2a6bed64870680d8$export$e1b32e613f230dc6(value) {
    return $2a6bed64870680d8$var$textEncoder.encode(value);
}
function $2a6bed64870680d8$export$db70ef86b2db322a(value) {
    return $2a6bed64870680d8$var$textDecoder.decode(value);
}
function $2a6bed64870680d8$export$30a71edf0753ed6b(value) {
    if (typeof value === "string") return $2a6bed64870680d8$export$e1b32e613f230dc6(value);
    if (value instanceof Uint8Array) return new Uint8Array(value);
    if (value instanceof ArrayBuffer) return new Uint8Array(value.slice(0));
    return new Uint8Array(value.buffer.slice(value.byteOffset, value.byteOffset + value.byteLength));
}
function $2a6bed64870680d8$export$230b06546aa82954(value) {
    if (value instanceof Uint8Array) return value;
    if (value instanceof ArrayBuffer) return new Uint8Array(value);
    return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
}
function $2a6bed64870680d8$export$287dd7971339c972(chunks) {
    let size = 0;
    for (const chunk of chunks)size += chunk.byteLength;
    const out = new Uint8Array(size);
    let offset = 0;
    for (const chunk of chunks){
        out.set(chunk, offset);
        offset += chunk.byteLength;
    }
    return out;
}
function $2a6bed64870680d8$export$f163bb7e7f385f7(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 2).getUint16(0, false);
}
function $2a6bed64870680d8$export$74c0812a28d8ac40(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 2).setUint16(0, value, false);
}
function $2a6bed64870680d8$export$fa598b0ff39af6cc(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 4).getUint32(0, false);
}
function $2a6bed64870680d8$export$a5bf86c9746bcbc2(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 4).setUint32(0, value, false);
}
function $2a6bed64870680d8$export$fc829b2afbae3c90(data, offset) {
    return new DataView(data.buffer, data.byteOffset + offset, 8).getBigUint64(0, false);
}
function $2a6bed64870680d8$export$50c532c203db6404(data, offset, value) {
    new DataView(data.buffer, data.byteOffset + offset, 8).setBigUint64(0, value, false);
}
const $2a6bed64870680d8$var$XXH32_PRIME_1 = 0x9e3779b1;
const $2a6bed64870680d8$var$XXH32_PRIME_2 = 0x85ebca77;
const $2a6bed64870680d8$var$XXH32_PRIME_3 = 0xc2b2ae3d;
const $2a6bed64870680d8$var$XXH32_PRIME_4 = 0x27d4eb2f;
const $2a6bed64870680d8$var$XXH32_PRIME_5 = 0x165667b1;
function $2a6bed64870680d8$export$59c89c9fda511ec(data, seed = 0) {
    let offset = 0;
    let hash;
    if (data.length >= 16) {
        let v1 = seed + $2a6bed64870680d8$var$XXH32_PRIME_1 + $2a6bed64870680d8$var$XXH32_PRIME_2 >>> 0;
        let v2 = seed + $2a6bed64870680d8$var$XXH32_PRIME_2 >>> 0;
        let v3 = seed >>> 0;
        let v4 = seed - $2a6bed64870680d8$var$XXH32_PRIME_1 >>> 0;
        const limit = data.length - 16;
        while(offset <= limit){
            v1 = $2a6bed64870680d8$var$xxHash32Round(v1, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v2 = $2a6bed64870680d8$var$xxHash32Round(v2, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v3 = $2a6bed64870680d8$var$xxHash32Round(v3, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
            v4 = $2a6bed64870680d8$var$xxHash32Round(v4, $2a6bed64870680d8$var$readU32Le(data, offset));
            offset += 4;
        }
        hash = $2a6bed64870680d8$var$rotl32(v1, 1) + $2a6bed64870680d8$var$rotl32(v2, 7) + $2a6bed64870680d8$var$rotl32(v3, 12) + $2a6bed64870680d8$var$rotl32(v4, 18) >>> 0;
    } else hash = seed + $2a6bed64870680d8$var$XXH32_PRIME_5 >>> 0;
    hash = hash + data.length >>> 0;
    while(offset + 4 <= data.length){
        hash = hash + Math.imul($2a6bed64870680d8$var$readU32Le(data, offset), $2a6bed64870680d8$var$XXH32_PRIME_3) >>> 0;
        hash = Math.imul($2a6bed64870680d8$var$rotl32(hash, 17), $2a6bed64870680d8$var$XXH32_PRIME_4) >>> 0;
        offset += 4;
    }
    while(offset < data.length){
        hash = hash + Math.imul(data[offset] ?? 0, $2a6bed64870680d8$var$XXH32_PRIME_5) >>> 0;
        hash = Math.imul($2a6bed64870680d8$var$rotl32(hash, 11), $2a6bed64870680d8$var$XXH32_PRIME_1) >>> 0;
        offset += 1;
    }
    hash ^= hash >>> 15;
    hash = Math.imul(hash, $2a6bed64870680d8$var$XXH32_PRIME_2) >>> 0;
    hash ^= hash >>> 13;
    hash = Math.imul(hash, $2a6bed64870680d8$var$XXH32_PRIME_3) >>> 0;
    hash ^= hash >>> 16;
    return hash >>> 0;
}
function $2a6bed64870680d8$export$8c79fc1ce37f06de(parts, seed = 0) {
    let size = 0;
    for (const part of parts)size += 4 + part.length;
    const data = new Uint8Array(size);
    let offset = 0;
    for (const part of parts){
        $2a6bed64870680d8$var$writeU32Le(data, offset, part.length);
        offset += 4;
        data.set(part, offset);
        offset += part.length;
    }
    return $2a6bed64870680d8$export$59c89c9fda511ec(data, seed);
}
function $2a6bed64870680d8$var$xxHash32Round(acc, value) {
    let next = acc + Math.imul(value, $2a6bed64870680d8$var$XXH32_PRIME_2) >>> 0;
    next = $2a6bed64870680d8$var$rotl32(next, 13);
    return Math.imul(next, $2a6bed64870680d8$var$XXH32_PRIME_1) >>> 0;
}
function $2a6bed64870680d8$var$rotl32(value, bits) {
    return (value << bits | value >>> 32 - bits) >>> 0;
}
function $2a6bed64870680d8$var$readU32Le(data, offset) {
    return ((data[offset] ?? 0) | (data[offset + 1] ?? 0) << 8 | (data[offset + 2] ?? 0) << 16 | (data[offset + 3] ?? 0) << 24) >>> 0;
}
function $2a6bed64870680d8$var$writeU32Le(data, offset, value) {
    data[offset] = value & 0xff;
    data[offset + 1] = value >>> 8 & 0xff;
    data[offset + 2] = value >>> 16 & 0xff;
    data[offset + 3] = value >>> 24 & 0xff;
}



const $3b990687ea5a342a$export$72747cb09ed23ab2 = "sdkDefault100Hz";
class $3b990687ea5a342a$export$90251372f1939aee {
    tenant;
    prefix;
    filter;
    constructor(tenant, prefix, filter){
        this.tenant = tenant;
        this.prefix = prefix;
        this.filter = filter;
    }
    /**
     * Checks if this filter must run for this message.
     */ matches(ctx) {
        return ctx.tenant === this.tenant && ctx.channel.startsWith(this.prefix);
    }
}
function $3b990687ea5a342a$export$a518a1ff0c180fcc(mode) {
    return {
        mode: mode,
        intervalMs: $3b990687ea5a342a$export$e52b86c7c25ac359(mode)
    };
}
function $3b990687ea5a342a$export$e52b86c7c25ac359(mode) {
    switch(mode){
        case "ultraLowLatency1000Hz":
            return 1;
        case "highFrequency500Hz":
            return 2;
        case "lowLatency200Hz":
            return 5;
        case "economy20Hz":
            return 50;
        case "slow10Hz":
            return 100;
        case "sdkDefault100Hz":
        default:
            return 10;
    }
}
async function $3b990687ea5a342a$export$e3ddf273e40fce27(filters, ctx, payload, meta) {
    return $3b990687ea5a342a$export$cf32509dd19cedfd(filters, filters.length, ctx, payload, meta);
}
async function $3b990687ea5a342a$export$cf32509dd19cedfd(filters, endIndex, ctx, payload, meta) {
    let payloads = [
        payload
    ];
    const end = Math.min(Math.max(0, endIndex), filters.length);
    for(let i = end - 1; i >= 0; i -= 1){
        const registration = filters[i];
        if (!registration?.matches(ctx)) continue;
        const next = [];
        for (const item of payloads)if (registration.filter.outbound) {
            const filtered = await registration.filter.outbound(ctx, item, meta);
            next.push(...filtered);
        } else next.push(item);
        payloads = next;
    }
    return payloads;
}
async function $3b990687ea5a342a$export$438723802648587b(filters, ctx, payload, meta) {
    let payloads = [
        payload
    ];
    const messages = [];
    for (const registration of filters){
        if (!registration.matches(ctx)) continue;
        const next = [];
        for (const item of payloads)if (registration.filter.inbound) {
            const result = await registration.filter.inbound(ctx, item, meta);
            next.push(...result.payloads);
            messages.push(...result.messages);
        } else next.push(item);
        payloads = next;
    }
    return {
        payloads: payloads,
        messages: messages
    };
}
function $3b990687ea5a342a$export$3a494e8f1895c44b(payload) {
    return {
        payloads: [
            payload
        ],
        messages: []
    };
}






const $9ebeb5fdd029b452$export$e818bad5c1128e7f = 1;
const $9ebeb5fdd029b452$export$165eab13b8aa7b99 = 0x0001;
const $9ebeb5fdd029b452$export$4d9a6b683a2fe834 = 0x0002;
const $9ebeb5fdd029b452$export$8d3a822fc375d7a3 = 0x0003;
const $9ebeb5fdd029b452$export$72ca7d3a57248cdd = 0x0004;
const $9ebeb5fdd029b452$export$bc4c0024bcac0400 = 0x0005;
const $9ebeb5fdd029b452$export$2c82e4acde754c20 = 0x0006;
const $9ebeb5fdd029b452$export$9e6b0bb213adbb66 = 0x0007;
const $9ebeb5fdd029b452$export$dd5de4bd32893730 = 0x0008;
const $9ebeb5fdd029b452$export$213b0026c188cc45 = 0x0009;
const $9ebeb5fdd029b452$export$59b74ed860b22bf8 = 0x000a;
const $9ebeb5fdd029b452$export$a752e0c4efca0558 = 0x000b;
const $9ebeb5fdd029b452$export$c43aba9a497fbbd8 = 1;
const $9ebeb5fdd029b452$export$61bbf024766606bf = 1;
const $9ebeb5fdd029b452$export$e63fed7c1e13426d = 2;
class $9ebeb5fdd029b452$export$90a59c3c1368656d {
    bytes;
    constructor(bytes){
        this.bytes = bytes ? (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(bytes) : new Uint8Array(0);
    }
    /**
     * Creates an empty metadata value.
     */ static none() {
        return new $9ebeb5fdd029b452$export$90a59c3c1368656d();
    }
    /**
     * Creates metadata from a binary blob.
     */ static blob(bytes) {
        return new $9ebeb5fdd029b452$export$90a59c3c1368656d(bytes);
    }
    /**
     * Returns true when there is no metadata.
     */ isEmpty() {
        return this.bytes.length === 0;
    }
    /**
     * Returns the record count from the header.
     */ stageCount() {
        if (this.isEmpty()) return 0;
        if (this.bytes.length < 2) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is too short");
        if (this.bytes[0] !== $9ebeb5fdd029b452$export$e818bad5c1128e7f) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata version is not supported");
        return this.bytes[1] ?? 0;
    }
    /**
     * Returns all metadata records.
     */ records() {
        return Array.from(new $9ebeb5fdd029b452$export$b079d20fca7984af(this.bytes));
    }
}
class $9ebeb5fdd029b452$export$ea11f29158edde53 {
    tenant;
    channel;
    matchedPattern;
    receivedAt;
    payload;
    meta;
    constructor(input){
        this.tenant = input.tenant;
        this.channel = input.channel;
        this.matchedPattern = input.matchedPattern;
        this.receivedAt = input.receivedAt ?? new Date();
        this.payload = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(input.payload);
        this.meta = input.meta ?? $9ebeb5fdd029b452$export$90a59c3c1368656d.none();
    }
    /**
     * Returns true when metadata exists.
     */ hasMetadata() {
        return !this.meta.isEmpty();
    }
}
class $9ebeb5fdd029b452$export$710aedf3f94c06a3 {
    chunks;
    countValue;
    constructor(){
        this.chunks = [
            new Uint8Array([
                $9ebeb5fdd029b452$export$e818bad5c1128e7f,
                0
            ])
        ];
        this.countValue = 0;
    }
    /**
     * Returns true when there are no records yet.
     */ isEmpty() {
        return this.countValue === 0;
    }
    /**
     * Adds one ready record.
     */ pushRecord(recordType, data) {
        if (this.countValue >= 255) throw new (0, $b09ac485321cc4ed$export$fe40046a1b08a9d7)("metadata records are more than 255");
        const body = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(data);
        if (body.length > 0xffff) throw new (0, $b09ac485321cc4ed$export$fe40046a1b08a9d7)("metadata record is too large");
        const header = new Uint8Array(4);
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(header, 0, recordType);
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(header, 2, body.length);
        this.chunks.push(header, body);
        this.countValue += 1;
        this.chunks[0][1] = this.countValue;
    }
    /**
     * Finishes the writer and returns metadata.
     */ finish() {
        if (this.countValue === 0) return $9ebeb5fdd029b452$export$90a59c3c1368656d.none();
        let size = 0;
        for (const chunk of this.chunks)size += chunk.length;
        const out = new Uint8Array(size);
        let offset = 0;
        for (const chunk of this.chunks){
            out.set(chunk, offset);
            offset += chunk.length;
        }
        return $9ebeb5fdd029b452$export$90a59c3c1368656d.blob(out);
    }
}
class $9ebeb5fdd029b452$export$b079d20fca7984af {
    data;
    countValue;
    constructor(data){
        this.data = (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(data);
        if (this.data.length < 2) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is too short");
        if (this.data[0] !== $9ebeb5fdd029b452$export$e818bad5c1128e7f) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata version is not supported");
        this.countValue = this.data[1] ?? 0;
    }
    /**
     * Returns the count written in the blob header.
     */ count() {
        return this.countValue;
    }
    *[Symbol.iterator]() {
        let offset = 2;
        for(let index = 0; index < this.countValue; index += 1){
            if (offset + 4 > this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
            const recordType = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(this.data, offset);
            const len = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(this.data, offset + 2);
            offset += 4;
            if (offset + len > this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
            const recordData = this.data.slice(offset, offset + len);
            offset += len;
            yield {
                recordType: recordType,
                data: recordData
            };
        }
        if (offset !== this.data.length) throw new (0, $b09ac485321cc4ed$export$6d29b48d1471e7e6)("metadata blob is corrupted");
    }
}



/**
 * Small async queue for subscription messages.
 *
 * `subscribe` returns this queue. You can read one message with `recv()`
 * or use `for await`.
 *
 * @example
 * ```ts
 * const queue = await client.subscribe("tenant_1", "public.#");
 *
 * for await (const message of queue) {
 *   console.log(message.channel, message.payload);
 * }
 * ```
 */ class $32761a3f8d3f5dc1$export$c24e73273208a9bb {
    capacity;
    items;
    waiters;
    closed;
    constructor(capacity = 256){
        this.capacity = Math.max(1, capacity);
        this.items = [];
        this.waiters = [];
        this.closed = false;
    }
    /**
     * Adds an item to the queue.
     *
     * Returns `false` when the queue is closed or full.
     */ push(item) {
        if (this.closed) return false;
        const waiter = this.waiters.shift();
        if (waiter) {
            waiter({
                value: item,
                done: false
            });
            return true;
        }
        if (this.items.length >= this.capacity) return false;
        this.items.push(item);
        return true;
    }
    /**
     * Reads one item without waiting.
     */ tryRecv() {
        return this.items.shift();
    }
    /**
     * Waits for one item.
     */ recv() {
        const item = this.items.shift();
        if (item !== undefined) return Promise.resolve(item);
        if (this.closed) return Promise.resolve(undefined);
        return new Promise((resolve)=>{
            this.waiters.push((result)=>{
                resolve(result.done ? undefined : result.value);
            });
        });
    }
    /**
     * Closes the queue and wakes all readers.
     */ close() {
        if (this.closed) return;
        this.closed = true;
        while(this.waiters.length > 0){
            const waiter = this.waiters.shift();
            waiter?.({
                value: undefined,
                done: true
            });
        }
    }
    /**
     * Returns the current number of items in the queue.
     */ len() {
        return this.items.length;
    }
    async *[Symbol.asyncIterator]() {
        while(true){
            const item = await this.recv();
            if (item === undefined) break;
            yield item;
        }
    }
}



const $1c6b3987498f62a9$export$d0a4d55fbab05d8f = 0x01;
const $1c6b3987498f62a9$export$2ba143b522a908f7 = 0x02;
const $1c6b3987498f62a9$export$6140aaf55daeb3d9 = "PING";
const $1c6b3987498f62a9$export$c5a04a3d52caa8d5 = "PONG";
function $1c6b3987498f62a9$export$19776548d9276c48(text) {
    return text === $1c6b3987498f62a9$export$c5a04a3d52caa8d5;
}
function $1c6b3987498f62a9$var$deliveryToWire(mode) {
    switch(mode){
        case "deliverOneLowLatency":
            return 1;
        case "deliverOneRandom":
            return 2;
        default:
            return 0;
    }
}
function $1c6b3987498f62a9$export$87699b10a0dfb985(tenant, channel, payload, delivery = "broadcast") {
    const tenantBytes = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(tenant);
    const channelBytes = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(channel);
    if (tenantBytes.length === 0 || channelBytes.length === 0) throw new Error("tenant and channel cannot be empty");
    if (tenantBytes.length > 0xffff || channelBytes.length > 0xffff) throw new Error("tenant or channel is too long");
    const headerLen = delivery === "broadcast" ? 0 : 2;
    const out = new Uint8Array(headerLen + 4 + tenantBytes.length + channelBytes.length + payload.length);
    let offset = 0;
    if (delivery !== "broadcast") {
        out[offset] = $1c6b3987498f62a9$export$2ba143b522a908f7;
        offset += 1;
        out[offset] = $1c6b3987498f62a9$var$deliveryToWire(delivery);
        offset += 1;
    }
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, tenantBytes.length);
    offset += 2;
    out.set(tenantBytes, offset);
    offset += tenantBytes.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, channelBytes.length);
    offset += 2;
    out.set(channelBytes, offset);
    offset += channelBytes.length;
    out.set(payload, offset);
    return out;
}
function $1c6b3987498f62a9$export$9dd0db4d64b6fad(data) {
    const first = $1c6b3987498f62a9$var$readUtf8Blob(data, 0, "tenant");
    const second = $1c6b3987498f62a9$var$readUtf8Blob(data, first.nextOffset, "channel");
    return {
        tenant: first.value,
        channel: second.value,
        payload: data.slice(second.nextOffset)
    };
}
function $1c6b3987498f62a9$export$a54a4302d87cbf6f(data) {
    if (data.length === 0) throw new Error("empty frame");
    if (data[0] !== $1c6b3987498f62a9$export$d0a4d55fbab05d8f) throw new Error("expected FRAME_TAG_DELIVER tag");
    const tenantPart = $1c6b3987498f62a9$var$readUtf8Blob(data, 1, "tenant");
    const channelPart = $1c6b3987498f62a9$var$readUtf8Blob(data, tenantPart.nextOffset, "channel");
    let offset = channelPart.nextOffset;
    if (offset + 4 > data.length) throw new Error("missing payload length");
    const payloadLen = (0, $2a6bed64870680d8$export$fa598b0ff39af6cc)(data, offset);
    offset += 4;
    if (offset + payloadLen > data.length) throw new Error("truncated payload");
    const payload = data.slice(offset, offset + payloadLen);
    offset += payloadLen;
    if (offset + 2 > data.length) throw new Error("missing pattern count");
    const patternCount = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(data, offset);
    offset += 2;
    const matchedPatterns = [];
    for(let i = 0; i < patternCount; i += 1){
        const patternPart = $1c6b3987498f62a9$var$readUtf8Blob(data, offset, "pattern");
        if (patternPart.value.length === 0) throw new Error("empty pattern in list");
        matchedPatterns.push(patternPart.value);
        offset = patternPart.nextOffset;
    }
    if (offset !== data.length) throw new Error("extra bytes after pattern list");
    if (matchedPatterns.length === 0) throw new Error("pattern list is empty");
    return {
        tenant: tenantPart.value,
        channel: channelPart.value,
        payload: payload,
        matchedPatterns: matchedPatterns
    };
}
function $1c6b3987498f62a9$export$d07d359e1d558cc1(tenant, channelPattern) {
    return `SUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$9538aafd0dfd1720(tenant, channelPattern) {
    return `UNSUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$b0e41c537aa6fe06(tenant, channelPattern) {
    return `OK:SUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$7c34c0e98969aadd(tenant, channelPattern) {
    return `OK:UNSUB:${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$22652ab787a185d4(text) {
    return text.startsWith("ERR:") ? text.slice(4) : undefined;
}
function $1c6b3987498f62a9$export$3c4e869fd5d68d6a(text) {
    if (text.startsWith("OK:SUB:")) {
        const parsed = $1c6b3987498f62a9$var$parseTenantPatternBody(text.slice(7));
        return parsed ? {
            kind: "sub",
            tenant: parsed.tenant,
            channelPattern: parsed.channelPattern
        } : undefined;
    }
    if (text.startsWith("OK:UNSUB:")) {
        const parsed = $1c6b3987498f62a9$var$parseTenantPatternBody(text.slice(9));
        return parsed ? {
            kind: "unsub",
            tenant: parsed.tenant,
            channelPattern: parsed.channelPattern
        } : undefined;
    }
    return undefined;
}
function $1c6b3987498f62a9$export$3c3308f3c5d34295(tenant, channelPattern) {
    return `${tenant}:${channelPattern}`;
}
function $1c6b3987498f62a9$export$2b1783cf5df3c65a(channelPattern) {
    if (channelPattern.trim().length === 0) throw new Error("channel pattern is invalid or empty");
}
function $1c6b3987498f62a9$var$parseTenantPatternBody(input) {
    const colon = input.indexOf(":");
    if (colon < 0) return undefined;
    const tenant = input.slice(0, colon).trim();
    const channelPattern = input.slice(colon + 1).trim();
    if (tenant.length === 0 || channelPattern.length === 0) return undefined;
    return {
        tenant: tenant,
        channelPattern: channelPattern
    };
}
function $1c6b3987498f62a9$var$readUtf8Blob(data, offset, field) {
    if (offset + 2 > data.length) throw new Error(`missing ${field} length`);
    const len = (0, $2a6bed64870680d8$export$f163bb7e7f385f7)(data, offset);
    offset += 2;
    if (len === 0) throw new Error(`empty ${field}`);
    if (offset + len > data.length) throw new Error(`truncated ${field}`);
    const value = (0, $2a6bed64870680d8$export$db70ef86b2db322a)(data.slice(offset, offset + len));
    return {
        value: value,
        nextOffset: offset + len
    };
}
function $1c6b3987498f62a9$export$331afb6eb63f25d5(input) {
    const tenant = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(input.tenant);
    const channel = (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(input.channel);
    const patterns = input.matchedPatterns.map((pattern)=>(0, $2a6bed64870680d8$export$e1b32e613f230dc6)(pattern));
    let size = 3 + tenant.length + 2 + channel.length + 4 + input.payload.length + 2;
    for (const pattern of patterns)size += 2 + pattern.length;
    const out = new Uint8Array(size);
    let offset = 0;
    out[offset] = $1c6b3987498f62a9$export$d0a4d55fbab05d8f;
    offset += 1;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, tenant.length);
    offset += 2;
    out.set(tenant, offset);
    offset += tenant.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, channel.length);
    offset += 2;
    out.set(channel, offset);
    offset += channel.length;
    (0, $2a6bed64870680d8$export$a5bf86c9746bcbc2)(out, offset, input.payload.length);
    offset += 4;
    out.set(input.payload, offset);
    offset += input.payload.length;
    (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, patterns.length);
    offset += 2;
    for (const pattern of patterns){
        (0, $2a6bed64870680d8$export$74c0812a28d8ac40)(out, offset, pattern.length);
        offset += 2;
        out.set(pattern, offset);
        offset += pattern.length;
    }
    return out;
}


/**
 * Ring buffer of RTT samples; one in-flight PING at a time.
 */ class $3a4dd3a15118ceeb$export$e1777e1915f479dc {
    samples = [];
    pendingSentAtMs;
    maxSamples;
    constructor(maxSamples = 120){
        this.maxSamples = Math.max(8, maxSamples);
    }
    /**
     * Starts a ping. Returns false if the previous ping is still pending.
     */ beginPing(nowMs = Date.now()) {
        if (this.pendingSentAtMs !== undefined) return false;
        this.pendingSentAtMs = nowMs;
        return true;
    }
    /**
     * Finishes a ping on PONG.
     */ recordPong(nowMs = Date.now()) {
        if (this.pendingSentAtMs === undefined) return undefined;
        const rttMs = Math.max(0, nowMs - this.pendingSentAtMs);
        this.pendingSentAtMs = undefined;
        this.pushSample(nowMs, rttMs);
        return rttMs;
    }
    /**
     * Clears a stuck pending ping.
     */ expirePending(timeoutMs, nowMs = Date.now()) {
        if (this.pendingSentAtMs === undefined) return;
        if (nowMs - this.pendingSentAtMs >= timeoutMs) this.pendingSentAtMs = undefined;
    }
    pushSample(atMs, rttMs) {
        if (this.samples.length >= this.maxSamples) this.samples.shift();
        this.samples.push({
            atMs: atMs,
            rttMs: rttMs
        });
    }
    lastRttMs() {
        const last = this.samples[this.samples.length - 1];
        return last?.rttMs;
    }
    medianRttMs(windowSec = 30, nowMs = Date.now()) {
        const cutoff = nowMs - windowSec * 1000;
        const values = this.samples.filter((s)=>s.atMs >= cutoff).map((s)=>s.rttMs);
        if (values.length === 0) return undefined;
        values.sort((a, b)=>a - b);
        const mid = Math.floor(values.length / 2);
        if (values.length % 2 === 1) return values[mid];
        return Math.floor((values[mid - 1] + values[mid]) / 2);
    }
    snapshot(windowSec = 30) {
        return {
            lastRttMs: this.lastRttMs(),
            medianRttMs: this.medianRttMs(windowSec)
        };
    }
}


const $854d7c88cb215c97$export$f8af265e214bdb59 = {
    queueCapacity: 256
};
const $854d7c88cb215c97$export$c0d2082e4d19b297 = {
    delivery: "broadcast"
};


const $ecb8a282c75664fb$var$WS_OPEN = 1;
const $ecb8a282c75664fb$var$OVERLAP_GRACE_MS = 5000;
const $ecb8a282c75664fb$var$OVERLAP_DEDUP_TTL_MS = $ecb8a282c75664fb$var$OVERLAP_GRACE_MS + 1000;
const $ecb8a282c75664fb$var$DEDUP_SEED_LO = 0x9e3779b1;
const $ecb8a282c75664fb$var$DEDUP_SEED_HI = 0x85ebca77;
class $ecb8a282c75664fb$export$de21836fc42c6f9c {
    kind = "websocket";
    endpoint = "";
    accessToken = "";
    ws;
    connectionId = 0;
    filters = [];
    filterTimerMode = (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
    metaMode = "none";
    onEvent;
    factory;
    subscriptions = new Map();
    dedup = new Map();
    filterTimer;
    filterTimerRunning = false;
    overlapDedupEnabled = false;
    overlapTimer;
    closedByUser = false;
    reconnecting = false;
    linkQualityTracker = new (0, $3a4dd3a15118ceeb$export$e1777e1915f479dc)();
    pingTimer;
    pingIntervalSec;
    /**
     * Opens the WebSocket connection.
     *
     * The builder usually calls this method.
     */ async connect(endpoint, params) {
        this.endpoint = endpoint;
        this.accessToken = params.accessToken;
        this.filters = params.filters ? [
            ...params.filters
        ] : [];
        this.filterTimerMode = params.filterTimerMode ?? (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
        this.metaMode = params.metaMode ?? "none";
        this.onEvent = params.onWebSocketEvent;
        this.factory = params.webSocketFactory;
        this.pingIntervalSec = $ecb8a282c75664fb$var$normalizePingInterval(params.pingIntervalSec);
        this.closedByUser = false;
        await this.openSocket(false);
        this.startFilterTimer();
        this.startPingTimer();
    }
    /**
     * Snapshot of WebSocket link quality (PING/PONG).
     */ linkQuality(windowSec = 30) {
        return this.linkQualityTracker.snapshot(windowSec);
    }
    /**
     * Publishes one payload.
     *
     * Success means that the transport accepted the message locally and sent it to the socket.
     */ async publish(tenant, channel, payload, options = {}) {
        const socket = this.requireOpenSocket();
        const delivery = options.delivery ?? (0, $854d7c88cb215c97$export$c0d2082e4d19b297).delivery;
        const ctx = {
            tenant: tenant,
            channel: channel
        };
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        const payloads = await (0, $3b990687ea5a342a$export$e3ddf273e40fce27)(this.filters, ctx, payload, meta);
        for (const item of payloads)socket.send((0, $1c6b3987498f62a9$export$87699b10a0dfb985)(tenant, channel, item, delivery));
    }
    /**
     * Subscribes to one channel pattern.
     *
     * @example
     * ```ts
     * const queue = await client.subscribe("tenant_1", "public.#");
     * const message = await queue.recv();
     * ```
     */ async subscribe(tenant, channelPattern, options = {}) {
        (0, $1c6b3987498f62a9$export$2b1783cf5df3c65a)(channelPattern);
        const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern);
        if (this.subscriptions.has(key)) throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("duplicate_subscription", "subscription with this tenant and pattern already exists");
        const queue = new (0, $32761a3f8d3f5dc1$export$c24e73273208a9bb)(options.queueCapacity ?? (0, $854d7c88cb215c97$export$f8af265e214bdb59).queueCapacity);
        this.subscriptions.set(key, {
            tenant: tenant,
            channelPattern: channelPattern,
            queue: queue
        });
        this.requireOpenSocket().send((0, $1c6b3987498f62a9$export$d07d359e1d558cc1)(tenant, channelPattern));
        return queue;
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern);
        const sub = this.subscriptions.get(key);
        if (sub) {
            sub.queue.close();
            this.subscriptions.delete(key);
        }
        this.requireOpenSocket().send((0, $1c6b3987498f62a9$export$9538aafd0dfd1720)(tenant, channelPattern));
    }
    /**
     * Closes the transport and local subscription queues.
     */ close() {
        this.closedByUser = true;
        this.stopFilterTimer();
        this.disableOverlapDedup();
        for (const sub of this.subscriptions.values())sub.queue.close();
        this.subscriptions.clear();
        this.ws?.close();
        this.ws = undefined;
    }
    requireOpenSocket() {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("not_connected", "transport is not connected");
        return socket;
    }
    async openSocket(isReconnect) {
        const socket = await $ecb8a282c75664fb$var$createSocket(this.endpoint, this.accessToken, this.factory);
        this.connectionId += 1;
        const currentId = this.connectionId;
        this.ws = socket;
        socket.binaryType = "arraybuffer";
        this.attachSocket(socket, currentId);
        await $ecb8a282c75664fb$var$waitForOpen(socket);
        if (isReconnect) {
            for (const sub of this.subscriptions.values())socket.send((0, $1c6b3987498f62a9$export$d07d359e1d558cc1)(sub.tenant, sub.channelPattern));
            this.enableOverlapDedup();
            this.emit({
                type: "reconnectReady"
            });
        }
    }
    attachSocket(socket, connectionId) {
        $ecb8a282c75664fb$var$addSocketListener(socket, "message", (event)=>{
            this.handleMessage(connectionId, event);
        });
        $ecb8a282c75664fb$var$addSocketListener(socket, "close", ()=>{
            if (!this.closedByUser && this.ws === socket) this.reconnectLoop();
        });
        $ecb8a282c75664fb$var$addSocketListener(socket, "error", (event)=>{
            this.emit({
                type: "error",
                error: {
                    type: "read",
                    connectionId: connectionId,
                    message: $ecb8a282c75664fb$var$eventToMessage(event)
                }
            });
        });
    }
    async reconnectLoop() {
        if (this.reconnecting || this.closedByUser) return;
        this.reconnecting = true;
        this.emit({
            type: "reconnectStarted"
        });
        let delayMs = 100;
        while(!this.closedByUser)try {
            await $ecb8a282c75664fb$var$sleep(delayMs);
            await this.openSocket(true);
            this.reconnecting = false;
            return;
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "reconnect",
                    connectionId: this.connectionId,
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
            delayMs = Math.min(delayMs * 2, 2000);
        }
        this.reconnecting = false;
    }
    async handleMessage(connectionId, event) {
        const data = $ecb8a282c75664fb$var$messageData(event);
        if (typeof data === "string") {
            this.handleText(data);
            return;
        }
        try {
            await this.handleBinary(connectionId, (0, $2a6bed64870680d8$export$230b06546aa82954)(data));
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "decode",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
    handleText(text) {
        if ((0, $1c6b3987498f62a9$export$19776548d9276c48)(text)) {
            const rttMs = this.linkQualityTracker.recordPong();
            if (rttMs !== undefined) this.emit({
                type: "rttMeasured",
                rttMs: rttMs
            });
            return;
        }
        const serverError = (0, $1c6b3987498f62a9$export$22652ab787a185d4)(text);
        if (serverError !== undefined) {
            this.emit({
                type: "error",
                error: {
                    type: "server",
                    message: serverError
                }
            });
            return;
        }
        const ack = (0, $1c6b3987498f62a9$export$3c4e869fd5d68d6a)(text);
        if (!ack) return;
        if (ack.kind === "sub") this.emit({
            type: "subscriptionConfirmed",
            tenant: ack.tenant,
            channelPattern: ack.channelPattern
        });
        else this.emit({
            type: "unsubscriptionConfirmed",
            tenant: ack.tenant,
            channelPattern: ack.channelPattern
        });
    }
    async handleBinary(connectionId, data) {
        const deliver = (0, $1c6b3987498f62a9$export$a54a4302d87cbf6f)(data);
        if (deliver.matchedPatterns.length === 0) {
            this.emit({
                type: "error",
                error: {
                    type: "emptyDelivery",
                    tenant: deliver.tenant,
                    channel: deliver.channel
                }
            });
            return;
        }
        const notices = [];
        const ctx = {
            tenant: deliver.tenant,
            channel: deliver.channel,
            emitFilterNotice: (notice)=>{
                notices.push(notice);
            }
        };
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        let result;
        try {
            result = await (0, $3b990687ea5a342a$export$438723802648587b)(this.filters, ctx, deliver.payload, meta);
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "inboundFilter",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
            return;
        }
        for (const notice of notices)this.emit({
            type: "filterNotice",
            level: notice.level,
            message: notice.message
        });
        for (const message of result.messages)await this.publish(message.tenant, message.channel, message.payload);
        if (result.payloads.length === 0) return;
        const dedupPayload = result.payloads.length === 1 ? result.payloads[0] : deliver.payload;
        if (this.isDuplicate(deliver.tenant, deliver.channel, dedupPayload)) {
            this.emit({
                type: "duplicateDropped"
            });
            return;
        }
        const missing = [];
        for (const pattern of deliver.matchedPatterns){
            const key = (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(deliver.tenant, pattern);
            const sub = this.subscriptions.get(key);
            if (!sub) {
                missing.push(pattern);
                continue;
            }
            for (const payload of result.payloads){
                const sdkMessage = new (0, $9ebeb5fdd029b452$export$ea11f29158edde53)({
                    tenant: deliver.tenant,
                    channel: deliver.channel,
                    matchedPattern: pattern,
                    receivedAt: new Date(),
                    payload: payload,
                    meta: this.metaMode === "stages" ? meta.finish() : (0, $9ebeb5fdd029b452$export$90a59c3c1368656d).none()
                });
                if (!sub.queue.push(sdkMessage)) this.emit({
                    type: "error",
                    error: {
                        type: "subscriptionQueueFull",
                        tenant: deliver.tenant,
                        channelPattern: pattern
                    }
                });
            }
        }
        if (missing.length > 0) this.emit({
            type: "error",
            error: {
                type: "missingSubscription",
                tenant: deliver.tenant,
                channelPatterns: missing
            }
        });
        this.filterTimerMode;
    }
    isDuplicate(tenant, channel, payload) {
        if (!this.overlapDedupEnabled) return false;
        const now = Date.now();
        for (const [key, expiresAt] of this.dedup)if (expiresAt <= now) this.dedup.delete(key);
        const key = $ecb8a282c75664fb$var$overlapDedupKey(tenant, channel, payload);
        if (this.dedup.has(key)) return true;
        this.dedup.set(key, now + $ecb8a282c75664fb$var$OVERLAP_DEDUP_TTL_MS);
        return false;
    }
    startFilterTimer() {
        this.stopFilterTimer();
        const intervalMs = (0, $3b990687ea5a342a$export$a518a1ff0c180fcc)(this.filterTimerMode).intervalMs;
        this.filterTimer = setInterval(()=>{
            this.tickFilterTimer();
        }, intervalMs);
        this.filterTimer.unref?.();
    }
    stopFilterTimer() {
        if (this.filterTimer) {
            clearInterval(this.filterTimer);
            this.filterTimer = undefined;
        }
        this.filterTimerRunning = false;
    }
    async tickFilterTimer() {
        if (this.filterTimerRunning || this.closedByUser) return;
        this.filterTimerRunning = true;
        try {
            const ctx = (0, $3b990687ea5a342a$export$a518a1ff0c180fcc)(this.filterTimerMode);
            for(let index = 0; index < this.filters.length; index += 1){
                const registration = this.filters[index];
                const onTimer = registration?.filter.onTimer;
                if (!registration || !onTimer) continue;
                let messages;
                try {
                    messages = await onTimer.call(registration.filter, ctx);
                } catch (error) {
                    this.emit({
                        type: "error",
                        error: {
                            type: "transport",
                            operation: "filter_timer",
                            message: $ecb8a282c75664fb$var$errorToMessage(error)
                        }
                    });
                    continue;
                }
                for (const message of messages)await this.publishTimerMessage(index, message);
            }
        } finally{
            this.filterTimerRunning = false;
        }
    }
    async publishTimerMessage(endIndex, message) {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) return;
        const meta = new (0, $9ebeb5fdd029b452$export$710aedf3f94c06a3)();
        const ctx = {
            tenant: message.tenant,
            channel: message.channel
        };
        try {
            const payloads = await (0, $3b990687ea5a342a$export$cf32509dd19cedfd)(this.filters, endIndex, ctx, message.payload, meta);
            for (const payload of payloads)socket.send((0, $1c6b3987498f62a9$export$87699b10a0dfb985)(message.tenant, message.channel, payload, "broadcast"));
        } catch (error) {
            this.emit({
                type: "error",
                error: {
                    type: "transport",
                    operation: "publish_until_filter_index",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
    enableOverlapDedup() {
        this.disableOverlapDedup();
        this.overlapDedupEnabled = true;
        this.overlapTimer = setTimeout(()=>{
            this.disableOverlapDedup();
        }, $ecb8a282c75664fb$var$OVERLAP_GRACE_MS);
    }
    disableOverlapDedup() {
        this.overlapDedupEnabled = false;
        this.dedup.clear();
        if (this.overlapTimer) {
            clearTimeout(this.overlapTimer);
            this.overlapTimer = undefined;
        }
    }
    emit(event) {
        this.onEvent?.(event);
    }
    startPingTimer() {
        this.stopPingTimer();
        if (!this.pingIntervalSec) return;
        const intervalMs = this.pingIntervalSec * 1000;
        this.pingTimer = setInterval(()=>{
            this.maybeSendPing();
        }, intervalMs);
    }
    stopPingTimer() {
        if (this.pingTimer) {
            clearInterval(this.pingTimer);
            this.pingTimer = undefined;
        }
    }
    async maybeSendPing() {
        const socket = this.ws;
        if (!socket || socket.readyState !== $ecb8a282c75664fb$var$WS_OPEN) return;
        if (!this.linkQualityTracker.beginPing()) {
            this.linkQualityTracker.expirePending(10000);
            return;
        }
        try {
            socket.send((0, $1c6b3987498f62a9$export$6140aaf55daeb3d9));
        } catch (error) {
            this.linkQualityTracker.expirePending(0);
            this.emit({
                type: "error",
                error: {
                    type: "transport",
                    operation: "ping",
                    message: $ecb8a282c75664fb$var$errorToMessage(error)
                }
            });
        }
    }
}
function $ecb8a282c75664fb$var$normalizePingInterval(value) {
    if (value === 1 || value === 3 || value === 5) return value;
    return undefined;
}
function $ecb8a282c75664fb$var$overlapDedupKey(tenant, channel, payload) {
    const parts = [
        (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(tenant),
        (0, $2a6bed64870680d8$export$e1b32e613f230dc6)(channel),
        payload
    ];
    const lo = (0, $2a6bed64870680d8$export$8c79fc1ce37f06de)(parts, $ecb8a282c75664fb$var$DEDUP_SEED_LO);
    const hi = (0, $2a6bed64870680d8$export$8c79fc1ce37f06de)(parts, $ecb8a282c75664fb$var$DEDUP_SEED_HI);
    return BigInt(hi) << 32n | BigInt(lo);
}
async function $ecb8a282c75664fb$var$createSocket(endpoint, accessToken, factory) {
    const protocols = [
        "llps.v1",
        `at.${accessToken}`
    ];
    if (factory) return factory(endpoint, protocols, accessToken);
    const BrowserWebSocket = globalThis.WebSocket;
    if (BrowserWebSocket) return new BrowserWebSocket(endpoint, protocols);
    const importer = new Function("name", "return import(name)");
    const mod = await importer("ws");
    return new mod.WebSocket(endpoint, protocols, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
function $ecb8a282c75664fb$var$addSocketListener(socket, type, listener) {
    if (socket.addEventListener) {
        socket.addEventListener(type, listener);
        return;
    }
    socket.on?.(type, listener);
}
function $ecb8a282c75664fb$var$waitForOpen(socket) {
    if (socket.readyState === $ecb8a282c75664fb$var$WS_OPEN) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        const onOpen = ()=>{
            cleanup();
            resolve();
        };
        const onError = (event)=>{
            cleanup();
            reject(new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("connect_failed", $ecb8a282c75664fb$var$eventToMessage(event)));
        };
        const cleanup = ()=>{
            socket.removeEventListener?.("open", onOpen);
            socket.removeEventListener?.("error", onError);
            socket.off?.("open", onOpen);
            socket.off?.("error", onError);
        };
        $ecb8a282c75664fb$var$addSocketListener(socket, "open", onOpen);
        $ecb8a282c75664fb$var$addSocketListener(socket, "error", onError);
    });
}
function $ecb8a282c75664fb$var$messageData(event) {
    if (typeof event === "object" && event !== null && "data" in event) {
        const data = event.data;
        if (typeof data === "string" || data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return data;
    }
    if (typeof event === "string" || event instanceof ArrayBuffer || ArrayBuffer.isView(event)) return event;
    if (Array.isArray(event) && event.length > 0) return (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(event[0]);
    throw new Error("unsupported WebSocket message data");
}
function $ecb8a282c75664fb$var$eventToMessage(event) {
    if (event instanceof Error) return event.message;
    if (typeof event === "string") return event;
    return "WebSocket event";
}
function $ecb8a282c75664fb$var$errorToMessage(error) {
    return error instanceof Error ? error.message : String(error);
}
function $ecb8a282c75664fb$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}



class $8585ef59a212420f$export$2a3746908af85482 {
    kind = "webtransport";
    async connect(_endpoint, _params) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async publish(_tenant, _channel, _payload, _options = {}) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async subscribe(_tenant, _channelPattern, _options = {}) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    async unsubscribe(_tenant, _channelPattern) {
        throw new (0, $b09ac485321cc4ed$export$8e68de6fb26f2236)("unsupported", "WebTransport is not implemented in contract v0.1");
    }
    close() {
    // Nothing is open in the placeholder.
    }
}




function $53649ab7bd2d4662$export$e9ddf1da8d18d6f(apiBase, path) {
    const base = apiBase.endsWith("/") ? apiBase : `${apiBase}/`;
    return new URL(path.replace(/^\/+/, ""), base).toString();
}
async function $53649ab7bd2d4662$export$b0613bdcd91c3d8(url, init = {}, config = {}, defaultTimeoutMs = 5000) {
    const fetchImpl = config.fetchImpl ?? globalThis.fetch;
    if (!fetchImpl) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("fetch_missing", "fetch is not available in this runtime");
    const controller = new AbortController();
    const externalSignal = init.signal;
    const abortFromCaller = ()=>controller.abort();
    if (externalSignal?.aborted) controller.abort();
    else externalSignal?.addEventListener("abort", abortFromCaller, {
        once: true
    });
    const timeout = setTimeout(()=>controller.abort(), config.timeoutMs ?? defaultTimeoutMs);
    try {
        return await fetchImpl(url, {
            ...init,
            signal: controller.signal
        });
    } catch (error) {
        throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("network_error", error instanceof Error ? error.message : String(error));
    } finally{
        clearTimeout(timeout);
        externalSignal?.removeEventListener("abort", abortFromCaller);
    }
}
async function $53649ab7bd2d4662$export$e03e3c24cd30661(response) {
    const body = await response.text();
    if (!response.ok) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_status", `HTTP ${response.status}: ${body}`);
    return body;
}


const $7f8afe2618a9f493$var$DEFAULT_MAX_CANDIDATES = 4;
const $7f8afe2618a9f493$var$DEFAULT_PING_TIMEOUT_MS = 1000;
const $7f8afe2618a9f493$var$DEFAULT_SELECTION_WINDOW_MS = 200;
function $7f8afe2618a9f493$export$c17ae9c1a44a5870(overlay) {
    return `https://${overlay}.fastpubsub.workers.dev/`;
}
async function $7f8afe2618a9f493$export$ccfc10b8bad1155a(apiBase, config = {}) {
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, config.timeoutMs ?? 3000);
}
async function $7f8afe2618a9f493$export$79b79b66fde39634(apiBases, config = {}) {
    const settled = await Promise.allSettled(apiBases.map(async (apiBase)=>{
        const durationMs = await $7f8afe2618a9f493$var$measureSecondPing(apiBase, config, config.timeoutMs ?? 3000);
        return {
            apiBase: apiBase,
            durationMs: durationMs
        };
    }));
    const timings = settled.filter((result)=>result.status === "fulfilled").map((result)=>result.value).sort((a, b)=>a.durationMs - b.durationMs);
    if (timings.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded");
    return {
        timings: timings.slice(0, 3)
    };
}
async function $7f8afe2618a9f493$export$8828a016a29f8730(apiBases, config = {}) {
    if (apiBases.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", "no base URLs for ping");
    const result = await $7f8afe2618a9f493$export$79b79b66fde39634(apiBases, config);
    const fastest = result.timings[0];
    if (!fastest) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", "no ping completed");
    return fastest;
}
async function $7f8afe2618a9f493$export$7c7678d71b4821d0(overlay, bootstrapUrl = $7f8afe2618a9f493$export$c17ae9c1a44a5870(overlay), config = {}) {
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)($7f8afe2618a9f493$var$cacheBustedUrl(bootstrapUrl, "_fps_bootstrap"), $7f8afe2618a9f493$var$getInit(), config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    const edges = parsed.edges ?? [];
    const candidates = edges.map((edge)=>{
        const host = typeof edge === "string" ? edge : edge.host;
        if (!host) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
        return $7f8afe2618a9f493$var$edgeCandidateFromHost(host);
    });
    if (candidates.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_candidates", "no edge candidates");
    return candidates;
}
async function $7f8afe2618a9f493$export$515d30759ec3d446(candidates, config = {}, options = {}) {
    if (candidates.length === 0) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_candidates", "no edge candidates");
    const probeCandidates = candidates.slice(0, $7f8afe2618a9f493$var$normalizeMaxCandidates(options.maxCandidates));
    const timings = await $7f8afe2618a9f493$var$probeCandidatesWithinBudget(probeCandidates, config, options);
    const fastest = timings[0];
    if (!fastest) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded");
    const candidate = probeCandidates.find((item)=>item.apiBase === fastest.apiBase);
    if (!candidate) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("candidate_not_found", "candidate not found after ping");
    return {
        candidate: candidate,
        pingMs: fastest.durationMs
    };
}
async function $7f8afe2618a9f493$var$probeCandidatesWithinBudget(candidates, config, options) {
    const pingTimeoutMs = $7f8afe2618a9f493$var$normalizePositiveMs(options.pingTimeoutMs, config.timeoutMs ?? $7f8afe2618a9f493$var$DEFAULT_PING_TIMEOUT_MS);
    const selectionWindowMs = $7f8afe2618a9f493$var$normalizeNonNegativeMs(options.selectionWindowMs, $7f8afe2618a9f493$var$DEFAULT_SELECTION_WINDOW_MS);
    const controllers = candidates.map(()=>new AbortController());
    const timings = [];
    return new Promise((resolve, reject)=>{
        let completed = 0;
        let finished = false;
        let selectionTimer;
        const finish = ()=>{
            if (finished) return;
            finished = true;
            if (selectionTimer !== undefined) clearTimeout(selectionTimer);
            for (const controller of controllers)controller.abort();
            timings.sort((a, b)=>a.durationMs - b.durationMs);
            if (timings.length > 0) resolve(timings);
            else reject(new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_reachable_edges", "no edge ping succeeded"));
        };
        candidates.forEach((candidate, index)=>{
            const controller = controllers[index];
            if (!controller) return;
            $7f8afe2618a9f493$var$measureSecondPing(candidate.apiBase, config, pingTimeoutMs, controller.signal).then((durationMs)=>{
                timings.push({
                    apiBase: candidate.apiBase,
                    durationMs: durationMs
                });
                if (timings.length === 1) {
                    if (selectionWindowMs === 0) finish();
                    else selectionTimer = setTimeout(finish, selectionWindowMs);
                }
            }).catch(()=>{
            // One unhealthy edge is expected; only fail if every probe failed.
            }).finally(()=>{
                completed += 1;
                if (completed === candidates.length) finish();
            });
        });
    });
}
async function $7f8afe2618a9f493$var$measureSecondPing(apiBase, config, timeoutMs, signal) {
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal);
    const started = $7f8afe2618a9f493$var$nowMs();
    await $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal);
    return $7f8afe2618a9f493$var$nowMs() - started;
}
async function $7f8afe2618a9f493$var$pingWithOptions(apiBase, config, timeoutMs, signal) {
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)($7f8afe2618a9f493$var$pingUrl(apiBase), $7f8afe2618a9f493$var$getInit(signal), {
        ...config,
        timeoutMs: timeoutMs
    }, timeoutMs);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    if (body.trim() !== "pong") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
}
function $7f8afe2618a9f493$var$pingUrl(apiBase) {
    return $7f8afe2618a9f493$var$cacheBustedUrl((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "ping"), "_fps_ping");
}
function $7f8afe2618a9f493$var$cacheBustedUrl(input, paramName) {
    const url = new URL(input);
    url.searchParams.set(paramName, `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    return url.toString();
}
function $7f8afe2618a9f493$var$getInit(signal) {
    return {
        method: "GET",
        ...signal ? {
            signal: signal
        } : {}
    };
}
function $7f8afe2618a9f493$var$edgeCandidateFromHost(rawHost) {
    const host = rawHost.trim().replace(/\/+$/, "");
    const idPart = host.split(".")[0] || host;
    return {
        id: `edge-${idPart}`,
        apiBase: `https://${host}`,
        wsEndpoint: `wss://${host}/ws`,
        wtEndpoint: `https://${host}/wt`,
        region: idPart.toUpperCase()
    };
}
function $7f8afe2618a9f493$var$normalizeMaxCandidates(value) {
    if (value === undefined) return $7f8afe2618a9f493$var$DEFAULT_MAX_CANDIDATES;
    return Math.max(1, Math.floor(value));
}
function $7f8afe2618a9f493$var$normalizePositiveMs(value, fallback) {
    return value === undefined ? fallback : Math.max(1, Math.floor(value));
}
function $7f8afe2618a9f493$var$normalizeNonNegativeMs(value, fallback) {
    return value === undefined ? fallback : Math.max(0, Math.floor(value));
}
function $7f8afe2618a9f493$var$nowMs() {
    return typeof performance !== "undefined" ? performance.now() : Date.now();
}
const $7f8afe2618a9f493$export$f54cbbc2cff05aed = $7f8afe2618a9f493$export$c17ae9c1a44a5870;
const $7f8afe2618a9f493$export$e6052fdb8776f969 = $7f8afe2618a9f493$export$79b79b66fde39634;
const $7f8afe2618a9f493$export$ba72dfbea5d94a82 = $7f8afe2618a9f493$export$8828a016a29f8730;
const $7f8afe2618a9f493$export$76fb33decda5ca8f = $7f8afe2618a9f493$export$7c7678d71b4821d0;
const $7f8afe2618a9f493$export$1bfd0a12bc35c623 = $7f8afe2618a9f493$export$515d30759ec3d446;



class $1adf30b58a83e819$export$6516fa0e9545d085 {
    tenant;
    channelPattern;
    queueCapacity;
    constructor(tenant, channelPattern, options = {}){
        this.tenant = tenant;
        this.channelPattern = channelPattern;
        this.queueCapacity = options.queueCapacity ?? 256;
    }
    /**
     * Returns the route key used by the transport.
     */ routeKey() {
        return (0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(this.tenant, this.channelPattern);
    }
}
class $1adf30b58a83e819$export$4f48298e83c3d5fd {
    items;
    constructor(){
        this.items = new Map();
    }
    /**
     * Returns number of records.
     */ len() {
        return this.items.size;
    }
    /**
     * Returns true when the registry is empty.
     */ isEmpty() {
        return this.items.size === 0;
    }
    /**
     * Returns ordered subscription list.
     */ subscriptions() {
        return Array.from(this.items.values()).sort((a, b)=>{
            const left = `${a.tenant}:${a.channelPattern}`;
            const right = `${b.tenant}:${b.channelPattern}`;
            return left.localeCompare(right);
        });
    }
    /**
     * Checks if a subscription exists.
     */ contains(tenant, channelPattern) {
        return this.items.has((0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern));
    }
    /**
     * Adds or replaces a subscription.
     */ insert(spec) {
        this.items.set(spec.routeKey(), spec);
    }
    /**
     * Removes a subscription.
     */ remove(tenant, channelPattern) {
        return this.items.delete((0, $1c6b3987498f62a9$export$3c3308f3c5d34295)(tenant, channelPattern));
    }
}


function $7b4d8a91271f1bc3$export$a66334a85aba09dd(overlay) {
    return `wss://${overlay}.fastpubsub.invalid/ws`;
}
class $7b4d8a91271f1bc3$export$84278c718a874505 {
    overlay;
    accessToken;
    transportFactory;
    endpointValue;
    apiBaseValue;
    filtersValue = [];
    filterTimerModeValue = (0, $3b990687ea5a342a$export$72747cb09ed23ab2);
    metaModeValue = "none";
    onWebSocketEventValue;
    httpConfigValue;
    webSocketFactoryValue;
    endpointResolverValue;
    pingIntervalSecValue;
    constructor(overlay, accessToken, transportFactory){
        this.overlay = overlay;
        this.accessToken = accessToken;
        this.transportFactory = transportFactory;
    }
    /**
     * Sets an explicit transport endpoint.
     */ endpoint(url) {
        this.endpointValue = url;
        return this;
    }
    /**
     * Defers endpoint resolution until `build()`.
     *
     * @internal Used by `FastPubSubSession`; applications normally should not
     * need to set an edge endpoint themselves.
     */ resolveEndpoint(resolver) {
        this.endpointResolverValue = resolver;
        return this;
    }
    /**
     * Sets REST API base URL.
     */ apiBase(url) {
        this.apiBaseValue = url;
        return this;
    }
    /**
     * Stores HTTP settings for REST helpers.
     */ httpConfig(config) {
        this.httpConfigValue = config;
        return this;
    }
    /**
     * Adds a filter for an exact tenant and static channel prefix.
     *
     * @example
     * ```ts
     * builder.addFilter("tenant_1", "private.", new EncryptionFilter(keys));
     * ```
     */ addFilter(tenant, prefix, filter) {
        this.filtersValue.push(new (0, $3b990687ea5a342a$export$90251372f1939aee)(tenant, prefix, filter));
        return this;
    }
    /**
     * Sets the filter timer rate.
     *
     * The timer is used by filters that send messages later.
     */ filterTimerMode(mode) {
        this.filterTimerModeValue = mode;
        return this;
    }
    /**
     * Sets metadata mode.
     */ metaMode(mode) {
        this.metaModeValue = mode;
        return this;
    }
    /**
     * Receives WebSocket transport events.
     */ onWebSocketEvent(handler) {
        this.onWebSocketEventValue = handler;
        return this;
    }
    /**
     * WS PING interval in seconds: 1, 3, or 5.
     */ pingIntervalSec(seconds) {
        this.pingIntervalSecValue = seconds;
        return this;
    }
    /**
     * Overrides WebSocket creation.
     *
     * This is useful for tests or custom integration.
     */ webSocketFactory(factory) {
        this.webSocketFactoryValue = factory;
        return this;
    }
    /**
     * Connects the transport and returns a ready client.
     */ async build() {
        let endpoint = this.endpointValue;
        let apiBase = this.apiBaseValue;
        if (!endpoint && this.endpointResolverValue) {
            const resolved = await this.endpointResolverValue();
            endpoint = resolved.endpoint;
            apiBase ??= resolved.apiBase;
        }
        endpoint ??= $7b4d8a91271f1bc3$export$a66334a85aba09dd(this.overlay);
        apiBase ??= `https://${this.overlay}.fastpubsub.com`;
        const transport = this.transportFactory();
        const params = {
            filters: this.filtersValue,
            filterTimerMode: this.filterTimerModeValue,
            metaMode: this.metaModeValue,
            accessToken: this.accessToken,
            ...this.onWebSocketEventValue ? {
                onWebSocketEvent: this.onWebSocketEventValue
            } : {},
            ...this.webSocketFactoryValue ? {
                webSocketFactory: this.webSocketFactoryValue
            } : {},
            ...this.pingIntervalSecValue ? {
                pingIntervalSec: this.pingIntervalSecValue
            } : {}
        };
        try {
            await transport.connect(endpoint, params);
        } catch (error) {
            throw new (0, $b09ac485321cc4ed$export$f91b299ee183332c)(error instanceof Error ? error.message : String(error));
        }
        return new $7b4d8a91271f1bc3$export$8c3e4b3a9b8f5384(transport, this.overlay, apiBase, this.httpConfigValue);
    }
}
class $7b4d8a91271f1bc3$export$8c3e4b3a9b8f5384 {
    transport;
    overlay;
    apiBaseValue;
    httpConfigValue;
    registry;
    constructor(transport, overlay, apiBaseValue, httpConfigValue = {}){
        this.transport = transport;
        this.overlay = overlay;
        this.apiBaseValue = apiBaseValue;
        this.httpConfigValue = httpConfigValue;
        this.registry = new (0, $1adf30b58a83e819$export$4f48298e83c3d5fd)();
    }
    /**
     * Returns overlay network name.
     */ overlayNetworkName() {
        return this.overlay;
    }
    /**
     * Returns REST API base URL.
     */ apiBase() {
        return this.apiBaseValue;
    }
    /**
     * Calls GET /ping on the selected edge.
     */ async ping() {
        await (0, $7f8afe2618a9f493$export$ccfc10b8bad1155a)(this.apiBaseValue, this.httpConfigValue);
    }
    /**
     * WebSocket link quality from PING/PONG (WebSocket transport only).
     */ linkQuality(windowSec = 30) {
        if (this.transport.kind !== "websocket") return {
            lastRttMs: undefined,
            medianRttMs: undefined
        };
        return this.transport.linkQuality(windowSec);
    }
    /**
     * Publishes a payload with default options.
     *
     * @example
     * ```ts
     * await client.publish("tenant_1", "public.chat", "hello");
     * ```
     */ async publish(tenant, channel, payload) {
        await this.publishWithOptions(tenant, channel, payload, {});
    }
    /**
     * Publishes a payload with explicit options.
     */ async publishWithOptions(tenant, channel, payload, options) {
        try {
            await this.transport.publish(tenant, channel, (0, $2a6bed64870680d8$export$30a71edf0753ed6b)(payload), options);
        } catch (error) {
            throw new (0, $b09ac485321cc4ed$export$107365fdc90b0143)(error instanceof Error ? error.message : String(error));
        }
    }
    /**
     * Subscribes to one channel pattern.
     *
     * @example
     * ```ts
     * const queue = await client.subscribe("tenant_1", "public.#");
     * const message = await queue.recv();
     * ```
     */ async subscribe(tenant, channelPattern, options = {}) {
        const queue = await this.transport.subscribe(tenant, channelPattern, options);
        this.registry.insert(new (0, $1adf30b58a83e819$export$6516fa0e9545d085)(tenant, channelPattern, options));
        return queue;
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        await this.transport.unsubscribe(tenant, channelPattern);
        this.registry.remove(tenant, channelPattern);
    }
    /**
     * Returns active subscriptions.
     */ subscriptions() {
        return this.registry.subscriptions();
    }
    /**
     * Returns the subscription registry.
     */ subscriptionRegistry() {
        return this.registry;
    }
    /**
     * Returns a cloneable shared handle.
     */ intoShared() {
        return new $7b4d8a91271f1bc3$export$2c330fa98aeeb8ed(this);
    }
    /**
     * Closes the transport.
     */ close() {
        this.transport.close();
    }
}
class $7b4d8a91271f1bc3$export$2c330fa98aeeb8ed {
    client;
    constructor(client){
        this.client = client;
    }
    /**
     * Publishes a payload.
     */ async publish(tenant, channel, payload) {
        await this.client.publish(tenant, channel, payload);
    }
    /**
     * Publishes a payload with options.
     */ async publishWithOptions(tenant, channel, payload, options) {
        await this.client.publishWithOptions(tenant, channel, payload, options);
    }
    /**
     * Subscribes by pattern.
     */ async subscribe(tenant, channelPattern, options = {}) {
        return this.client.subscribe(tenant, channelPattern, options);
    }
    /**
     * Removes one subscription.
     */ async unsubscribe(tenant, channelPattern) {
        await this.client.unsubscribe(tenant, channelPattern);
    }
}
function $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33(overlayNetworkName, accessToken) {
    return new $7b4d8a91271f1bc3$export$84278c718a874505(overlayNetworkName, accessToken, ()=>new (0, $ecb8a282c75664fb$export$de21836fc42c6f9c)());
}
function $7b4d8a91271f1bc3$export$ac45ba05e245bb5(overlayNetworkName, accessToken) {
    return new $7b4d8a91271f1bc3$export$84278c718a874505(overlayNetworkName, accessToken, ()=>new (0, $8585ef59a212420f$export$2a3746908af85482)());
}
const $7b4d8a91271f1bc3$export$8bb841525d28fe13 = $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33;
const $7b4d8a91271f1bc3$export$26bb66da6a9d26ca = $7b4d8a91271f1bc3$export$ac45ba05e245bb5;
const $7b4d8a91271f1bc3$export$6eaf4d6852fd2635 = $7b4d8a91271f1bc3$export$a66334a85aba09dd;





const $447306b32f7f74c2$export$91bb716aaa6fe872 = 24;
const $447306b32f7f74c2$export$692878036c6bb647 = 1;
const $447306b32f7f74c2$export$89bb976f9be71f51 = $447306b32f7f74c2$export$692878036c6bb647;
function $447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    return new Date(Date.now() - Math.max(0, nowMarginSecs) * 1000);
}
function $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    return new Date($447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs).getTime() + $447306b32f7f74c2$export$91bb716aaa6fe872 * 3600000);
}
function $447306b32f7f74c2$export$c3e2c340c4359aaf(seconds, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const value = new Date($447306b32f7f74c2$export$351651ddf8e40050(nowMarginSecs).getTime() + Math.max(0, seconds) * 1000);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    return value > max ? max : value;
}
function $447306b32f7f74c2$export$89be358b786965fa(date) {
    return date.toISOString().replace(/\.\d{3}Z$/, "Z");
}
function $447306b32f7f74c2$export$b758f1bd88434b6b(input, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const date = $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    if (date > max) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("ttl_too_long", `expiration is after maximum TTL ${$447306b32f7f74c2$export$91bb716aaa6fe872}h`);
    return $447306b32f7f74c2$export$89be358b786965fa(date);
}
function $447306b32f7f74c2$export$8b34c4aa4b4e77d2(input, nowMarginSecs = $447306b32f7f74c2$export$692878036c6bb647) {
    const date = $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs);
    const max = $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    return $447306b32f7f74c2$export$89be358b786965fa(date > max ? max : date);
}
function $447306b32f7f74c2$var$parseExpiresAtDate(input, nowMarginSecs) {
    const trimmed = input.trim();
    if (trimmed.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expiration string is empty");
    const lower = trimmed.toLowerCase();
    if (lower === "max" || lower === "max_ttl" || lower === "24h") return $447306b32f7f74c2$export$7c5b7b485f5acc5b(nowMarginSecs);
    const relative = $447306b32f7f74c2$var$parseRelative(lower, nowMarginSecs);
    if (relative) return relative;
    const absolute = $447306b32f7f74c2$var$parseAbsolute(trimmed);
    if (absolute) return absolute;
    throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", `expected RFC3339, date YYYY-MM-DD, +1h/+30m, or max; got: ${input}`);
}
function $447306b32f7f74c2$var$parseRelative(input, nowMarginSecs) {
    const body = input.startsWith("+") ? input.slice(1) : input;
    const match = /^(\d+)\s*([a-z]*)$/.exec(body);
    if (!match) return undefined;
    const amount = Number(match[1]);
    const unit = match[2] ?? "";
    const factor = $447306b32f7f74c2$var$unitToSeconds(unit);
    if (factor === undefined) return undefined;
    return $447306b32f7f74c2$export$c3e2c340c4359aaf(amount * factor, nowMarginSecs);
}
function $447306b32f7f74c2$var$unitToSeconds(unit) {
    if (unit === "" || unit === "s" || unit === "sec" || unit === "secs" || unit === "second" || unit === "seconds") return 1;
    if (unit === "m" || unit === "min" || unit === "mins" || unit === "minute" || unit === "minutes") return 60;
    if (unit === "h" || unit === "hr" || unit === "hrs" || unit === "hour" || unit === "hours") return 3600;
    return undefined;
}
function $447306b32f7f74c2$var$parseAbsolute(input) {
    const normalized = /^\d{4}-\d{2}-\d{2}$/.test(input) ? `${input}T23:59:59Z` : input;
    const withZone = /z$|[+-]\d{2}:\d{2}$/i.test(normalized) ? normalized : `${normalized}Z`;
    const date = new Date(withZone);
    return Number.isNaN(date.getTime()) ? undefined : date;
}


class $f6ceae4a600c8ad0$export$e3c687fb6431a6b3 {
    tenantIds;
    allowChannelsPub;
    allowChannelsSub;
    constructor(tenantIds, allowChannelsPub = [], allowChannelsSub = []){
        this.tenantIds = tenantIds;
        this.allowChannelsPub = allowChannelsPub;
        this.allowChannelsSub = allowChannelsSub;
    }
    /**
     * Sets publish channel patterns.
     */ allowPub(channels) {
        return new $f6ceae4a600c8ad0$export$e3c687fb6431a6b3(this.tenantIds, channels, this.allowChannelsSub);
    }
    /**
     * Sets subscribe channel patterns.
     */ allowSub(channels) {
        return new $f6ceae4a600c8ad0$export$e3c687fb6431a6b3(this.tenantIds, this.allowChannelsPub, channels);
    }
    /**
     * Converts this grant to API JSON.
     */ toJson() {
        return {
            tenant_ids: this.tenantIds,
            allow_channels_pub: this.allowChannelsPub,
            allow_channels_sub: this.allowChannelsSub
        };
    }
}
class $f6ceae4a600c8ad0$export$f0bf26cea86c61ac {
    createdByValue = "";
    descriptionValue;
    expiresAtValue = "";
    tenantGrantsValue = [];
    allowIpMasksValue = [];
    allowRegionsValue = [];
    allowedWsOriginValue = [];
    nowMarginSecsValue = (0, $447306b32f7f74c2$export$692878036c6bb647);
    /**
     * Sets who creates the token.
     */ createdBy(value) {
        this.createdByValue = value;
        return this;
    }
    /**
     * Sets optional description.
     */ description(value) {
        this.descriptionValue = value;
        return this;
    }
    /**
     * Sets expiration. Accepts RFC3339, +1h, +30m, or max.
     */ expiresAt(value) {
        this.expiresAtValue = (0, $447306b32f7f74c2$export$8b34c4aa4b4e77d2)(value, this.nowMarginSecsValue);
        return this;
    }
    /**
     * Sets expiration in seconds from now.
     */ expiresInSeconds(value) {
        this.expiresAtValue = (0, $447306b32f7f74c2$export$8b34c4aa4b4e77d2)(`+${Math.max(0, value)}s`, this.nowMarginSecsValue);
        return this;
    }
    /**
     * Sets the margin used for relative expiration.
     */ nowMarginSecs(value) {
        this.nowMarginSecsValue = Math.max(0, value);
        return this;
    }
    /**
     * Adds one tenant grant.
     */ addTenantGrant(grant) {
        this.tenantGrantsValue.push(grant);
        return this;
    }
    /**
     * Sets allowed IP masks.
     */ allowIpMasks(values) {
        this.allowIpMasksValue = values;
        return this;
    }
    /**
     * Sets allowed regions.
     */ allowRegions(values) {
        this.allowRegionsValue = values;
        return this;
    }
    /**
     * Sets allowed WebSocket origins.
     */ allowedWsOrigin(values) {
        this.allowedWsOriginValue = values;
        return this;
    }
    /**
     * Builds the request object.
     */ build() {
        const request = {
            right: {
                tenant_grants: this.tenantGrantsValue.map((grant)=>grant.toJson()),
                allow_ip_masks: this.allowIpMasksValue,
                allow_regions: this.allowRegionsValue,
                allowed_ws_origin: this.allowedWsOriginValue,
                expires_at: this.expiresAtValue
            },
            created_by: this.createdByValue
        };
        if (this.descriptionValue !== undefined) request.description = this.descriptionValue;
        $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request);
        return request;
    }
}
function $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request) {
    if (request.created_by.trim().length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_created_by", "created_by is missing");
    if (request.right.expires_at.trim().length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_expires_at", "expires_at is missing");
    if (request.right.tenant_grants.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("no_tenant_grants", "at least one tenant grant is required");
    if (Number.isNaN(new Date(request.right.expires_at).getTime())) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expires_at must be RFC3339");
}
function $f6ceae4a600c8ad0$export$6f7af3e3db176cf7(fullToken) {
    const trimmed = fullToken.trim();
    if (!trimmed.startsWith("AT_")) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_access_token", "expected AT_{token_id}_{secret}");
    const rest = trimmed.slice(3);
    const sep = rest.indexOf("_");
    if (sep <= 0 || sep === rest.length - 1) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_access_token", "expected AT_{token_id}_{secret}");
    return {
        tokenId: rest.slice(0, sep),
        secret: rest.slice(sep + 1)
    };
}
function $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3(fullToken) {
    return $f6ceae4a600c8ad0$export$6f7af3e3db176cf7(fullToken).tokenId;
}
async function $f6ceae4a600c8ad0$export$916220f68f0e45e5(apiBase, masterToken, request, config = {}) {
    $f6ceae4a600c8ad0$export$850bfc2a4e5d4d2a(request);
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/get-token"), {
        method: "POST",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    if (!parsed.token || typeof parsed.token !== "string") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
    return {
        token: parsed.token
    };
}
async function $f6ceae4a600c8ad0$export$f8f36faf9a051362(apiBase, masterToken, tokenId, expiresAt, config = {}) {
    const id = tokenId.trim();
    const expires = expiresAt.trim();
    if (id.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_token_id", "token_id is missing");
    if (expires.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_expires_at", "expires_at is missing");
    if (Number.isNaN(new Date(expires).getTime())) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("invalid_expires_at", "expires_at must be RFC3339");
    const request = {
        token_id: id,
        expires_at: expires
    };
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/refresh-token"), {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    if (!parsed.new_expires_at || typeof parsed.new_expires_at !== "string") throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("unexpected_body", body);
    return {
        message: typeof parsed.message === "string" ? parsed.message : "Token refreshed successfully",
        newExpiresAt: parsed.new_expires_at
    };
}
async function $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024(apiBase, masterToken, fullToken, expiresAt, config = {}) {
    return $f6ceae4a600c8ad0$export$f8f36faf9a051362(apiBase, masterToken, $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3(fullToken), expiresAt, config);
}
async function $f6ceae4a600c8ad0$export$c545d41f704a57a7(apiBase, masterToken, fullToken, config = {}) {
    const token = fullToken.trim();
    if (token.length === 0) throw new (0, $b09ac485321cc4ed$export$f2e832acab1bdd79)("missing_token", "token is missing");
    const response = await (0, $53649ab7bd2d4662$export$b0613bdcd91c3d8)((0, $53649ab7bd2d4662$export$e9ddf1da8d18d6f)(apiBase, "v1/revoke-token"), {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${masterToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            token: token
        })
    }, config, 5000);
    const body = await (0, $53649ab7bd2d4662$export$e03e3c24cd30661)(response);
    const parsed = JSON.parse(body);
    return {
        message: typeof parsed.message === "string" ? parsed.message : "Token revoked successfully"
    };
}
const $f6ceae4a600c8ad0$export$de5e95458a713c61 = $f6ceae4a600c8ad0$export$916220f68f0e45e5;
const $f6ceae4a600c8ad0$export$5142c9336d33d01d = $f6ceae4a600c8ad0$export$f8f36faf9a051362;
const $f6ceae4a600c8ad0$export$f60e5fd39a50d50c = $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024;
const $f6ceae4a600c8ad0$export$687eed2ded992a6e = $f6ceae4a600c8ad0$export$c545d41f704a57a7;
const $f6ceae4a600c8ad0$export$cbc0d1e87065ccdf = $f6ceae4a600c8ad0$export$8b0ffa74f6edb4a3;
const $f6ceae4a600c8ad0$export$94ff8cca0cbab77c = $f6ceae4a600c8ad0$export$6f7af3e3db176cf7;



const $20120b594434c913$var$DEFAULT_CACHE_TTL_MS = 86400000;
/** Reject a cached edge when a fresh ping is worse than this multiple of the stored RTT. */ const $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH = 1.5;
/** How often the +50% latency check may trigger a full reselect. Default: 1 hour. */ const $20120b594434c913$var$DEFAULT_CACHE_LATENCY_RECHECK_MS = 3600000;
const $20120b594434c913$var$EDGE_CACHE_PREFIX = "fastpubsub-sdk:edge:v1:";
class $20120b594434c913$export$83e714cfa95a61b3 {
    entries = new Map();
    async get(overlay) {
        return this.entries.get(overlay);
    }
    async set(overlay, entry) {
        this.entries.set(overlay, entry);
    }
    async remove(overlay) {
        this.entries.delete(overlay);
    }
}
const $20120b594434c913$var$memoryCache = new $20120b594434c913$export$83e714cfa95a61b3();
class $20120b594434c913$export$7482d94cdafffc18 {
    overlay;
    httpConfig;
    bootstrapUrl;
    candidatesValue = [];
    selectedEdgeValue;
    constructor(overlay, httpConfig = {}, bootstrapUrl = (0, $7f8afe2618a9f493$export$c17ae9c1a44a5870)(overlay)){
        this.overlay = overlay;
        this.httpConfig = httpConfig;
        this.bootstrapUrl = bootstrapUrl;
    }
    /**
     * Downloads edge candidates.
     */ async discoverEdges() {
        this.candidatesValue = await (0, $7f8afe2618a9f493$export$7c7678d71b4821d0)(this.overlay, this.bootstrapUrl, this.httpConfig);
        return [
            ...this.candidatesValue
        ];
    }
    /**
     * Selects the nearest edge by ping. Does not consult persistent cache.
     */ async selectNearestEdge(options = {}) {
        if (this.candidatesValue.length === 0) await this.discoverEdges();
        this.selectedEdgeValue = await (0, $7f8afe2618a9f493$export$515d30759ec3d446)(this.candidatesValue, this.httpConfig, options);
        return this.selectedEdgeValue;
    }
    /**
     * Runs discovery and fast edge selection.
     *
     * With `{ cache: "prefer" }`, a validated cached edge skips bootstrap and
     * the multi-edge probe. A live edge is reused; at most once per
     * `cacheLatencyRecheckMs` (default 1 hour) the SDK compares fresh RTT to the
     * stored `pingMs` and rediscovers if growth exceeds `cacheMaxLatencyGrowth`
     * (default 1.5). Ping failure or TTL expiry always falls back to full selection.
     */ async resolveEdge(options = {}) {
        if (this.selectedEdgeValue && !options.forceRefresh) return this.selectedEdgeValue;
        const cacheMode = options.cache ?? "disabled";
        const edgeCache = options.edgeCache ?? $20120b594434c913$var$defaultEdgeCache();
        if (cacheMode === "prefer" && !options.forceRefresh) {
            const cached = await $20120b594434c913$var$readFreshCacheEntry(edgeCache, this.overlay, options.cacheTtlMs);
            if (cached) try {
                const timing = await (0, $7f8afe2618a9f493$export$8828a016a29f8730)([
                    cached.selected.candidate.apiBase
                ], {
                    ...this.httpConfig,
                    timeoutMs: options.pingTimeoutMs ?? this.httpConfig.timeoutMs ?? 1000
                });
                const now = Date.now();
                const recheckMs = Math.max(0, options.cacheLatencyRecheckMs ?? $20120b594434c913$var$DEFAULT_CACHE_LATENCY_RECHECK_MS);
                const lastCheck = cached.lastLatencyCheckAtMs ?? 0;
                const latencyCheckDue = now - lastCheck >= recheckMs;
                const maxGrowth = options.cacheMaxLatencyGrowth ?? $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH;
                if (latencyCheckDue && !$20120b594434c913$export$5e1dfe105b4e6493(cached.selected.pingMs, timing.durationMs, maxGrowth)) await $20120b594434c913$var$removeCacheEntry(edgeCache, this.overlay);
                else {
                    this.selectedEdgeValue = {
                        candidate: cached.selected.candidate,
                        pingMs: timing.durationMs
                    };
                    this.candidatesValue = [
                        cached.selected.candidate
                    ];
                    await $20120b594434c913$var$writeCacheEntry(edgeCache, this.overlay, {
                        // On a due latency check, store the fresh RTT as the new baseline.
                        // Between checks keep the previous baseline so the hourly compare is stable.
                        selected: latencyCheckDue ? this.selectedEdgeValue : cached.selected,
                        savedAtMs: cached.savedAtMs,
                        lastLatencyCheckAtMs: latencyCheckDue ? now : cached.lastLatencyCheckAtMs ?? lastCheck
                    });
                    return this.selectedEdgeValue;
                }
            } catch  {
                await $20120b594434c913$var$removeCacheEntry(edgeCache, this.overlay);
            }
        }
        await this.discoverEdges();
        const selected = await this.selectNearestEdge(options);
        if (cacheMode === "prefer") {
            const now = Date.now();
            await $20120b594434c913$var$writeCacheEntry(edgeCache, this.overlay, {
                selected: selected,
                savedAtMs: now,
                lastLatencyCheckAtMs: now
            });
        }
        return selected;
    }
    /**
     * Returns the selected edge.
     */ selectedEdge() {
        return this.selectedEdgeValue;
    }
    /**
     * Returns selected REST base URL.
     */ apiBase() {
        const selected = this.selectedEdgeValue;
        if (!selected) throw new (0, $b09ac485321cc4ed$export$9f48ca187ff38621)("no_edge_selected", "edge is not selected, call resolveEdge");
        return selected.candidate.apiBase;
    }
    /**
     * Creates an access token on an automatically selected edge.
     *
     * This is primarily useful for trusted Node.js/backend applications. Browser
     * applications should request an access token from their own backend instead
     * of exposing a master token.
     */ async createAccessToken(masterToken, request, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$916220f68f0e45e5)(selected.candidate.apiBase, masterToken, request, this.httpConfig);
    }
    /**
     * Extends AT expiry on an automatically selected edge (`PUT /v1/refresh-token`).
     *
     * Backend/trusted use only — requires a master token. Pass `tokenId` (not the secret).
     */ async refreshAccessToken(masterToken, tokenId, expiresAt, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$f8f36faf9a051362)(selected.candidate.apiBase, masterToken, tokenId, expiresAt, this.httpConfig);
    }
    /**
     * Same as {@link refreshAccessToken}, but accepts a full `AT_...` string.
     */ async refreshAccessTokenFromAt(masterToken, fullToken, expiresAt, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$5dbbe2e0b2a7d024)(selected.candidate.apiBase, masterToken, fullToken, expiresAt, this.httpConfig);
    }
    /**
     * Revokes an access token on an automatically selected edge (`DELETE /v1/revoke-token`).
     *
     * Backend/trusted use only — requires a master token and the full `AT_...`.
     */ async revokeAccessToken(masterToken, fullToken, options = {}) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer",
            ...options
        });
        return (0, $f6ceae4a600c8ad0$export$c545d41f704a57a7)(selected.candidate.apiBase, masterToken, fullToken, this.httpConfig);
    }
    /**
     * Creates a WebSocket builder. If no edge is selected yet, `build()` resolves
     * one automatically with the validated cache fast path enabled.
     */ webSocket(accessToken) {
        return (0, $7b4d8a91271f1bc3$export$3454ddbbf9ef1f33)(this.overlay, accessToken).resolveEndpoint(()=>this.resolveTransportEndpoint("websocket")).httpConfig(this.httpConfig);
    }
    /**
     * Creates a WebTransport builder. Edge resolution is deferred until `build()`.
     */ webTransport(accessToken) {
        return (0, $7b4d8a91271f1bc3$export$ac45ba05e245bb5)(this.overlay, accessToken).resolveEndpoint(()=>this.resolveTransportEndpoint("webtransport")).httpConfig(this.httpConfig);
    }
    async resolveTransportEndpoint(transport) {
        const selected = this.selectedEdgeValue ?? await this.resolveEdge({
            cache: "prefer"
        });
        return {
            endpoint: transport === "websocket" ? selected.candidate.wsEndpoint : selected.candidate.wtEndpoint ?? selected.candidate.apiBase,
            apiBase: selected.candidate.apiBase
        };
    }
}
function $20120b594434c913$export$3ce6949f20cea765(overlay, config = {}) {
    return new $20120b594434c913$export$7482d94cdafffc18(overlay, config);
}
function $20120b594434c913$var$defaultEdgeCache() {
    try {
        if (typeof localStorage !== "undefined") return $20120b594434c913$var$localStorageEdgeCache;
    } catch  {
    // Access to localStorage can be blocked by browser privacy settings.
    }
    return $20120b594434c913$var$memoryCache;
}
const $20120b594434c913$var$localStorageEdgeCache = {
    async get (overlay) {
        try {
            const raw = localStorage.getItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`);
            if (!raw) return undefined;
            const entry = JSON.parse(raw);
            return $20120b594434c913$var$isCacheEntry(entry) ? entry : undefined;
        } catch  {
            return undefined;
        }
    },
    async set (overlay, entry) {
        try {
            localStorage.setItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`, JSON.stringify(entry));
        } catch  {
        // The cache is an optional fast path, not a reason to fail discovery.
        }
    },
    async remove (overlay) {
        try {
            localStorage.removeItem(`${$20120b594434c913$var$EDGE_CACHE_PREFIX}${overlay}`);
        } catch  {
        // Ignore storage failures.
        }
    }
};
function $20120b594434c913$var$isCacheEntry(value) {
    if (!value || typeof value !== "object") return false;
    const entry = value;
    const candidate = entry.selected?.candidate;
    return typeof entry.savedAtMs === "number" && typeof entry.selected?.pingMs === "number" && typeof candidate?.id === "string" && typeof candidate.apiBase === "string" && typeof candidate.wsEndpoint === "string";
}
function $20120b594434c913$export$5e1dfe105b4e6493(cachedPingMs, currentPingMs, maxGrowth = $20120b594434c913$var$DEFAULT_CACHE_MAX_LATENCY_GROWTH) {
    if (!(cachedPingMs > 0) || !(currentPingMs >= 0) || !(maxGrowth > 0)) return true;
    return currentPingMs <= cachedPingMs * maxGrowth;
}
async function $20120b594434c913$var$readFreshCacheEntry(edgeCache, overlay, ttlMs) {
    try {
        const entry = await edgeCache.get(overlay);
        const maxAgeMs = Math.max(0, ttlMs ?? $20120b594434c913$var$DEFAULT_CACHE_TTL_MS);
        if (!entry || Date.now() - entry.savedAtMs > maxAgeMs) {
            if (entry) await edgeCache.remove(overlay);
            return undefined;
        }
        return entry;
    } catch  {
        return undefined;
    }
}
async function $20120b594434c913$var$writeCacheEntry(edgeCache, overlay, entry) {
    try {
        await edgeCache.set(overlay, entry);
    } catch  {
    // The selected edge is still valid if the optional cache cannot be written.
    }
}
async function $20120b594434c913$var$removeCacheEntry(edgeCache, overlay) {
    try {
        await edgeCache.remove(overlay);
    } catch  {
    // Ignore cache cleanup failures.
    }
}

/**
 * Limits the send rate and keeps only the latest payload.
 *
 * The first payload is sent at once. If new payloads arrive too often,
 * the filter keeps only the newest one and sends it on the next timer tick.
 *
 * This is useful for player position, mouse cursor data, and other values
 * where old state is no longer important.
 *
 * @example
 * ```ts
 * const client = await createWebSocket("globaltest", "AT_token")
 *   .filterTimerMode("lowLatency200Hz")
 *   .addFilter("tenant_1", "player.position.", SendRateFilter.fromMillis(33))
 *   .build();
 * ```
 */ class $6d4ece1462c3dd3e$export$47d2778fe368ca9f {
    minIntervalMs;
    entries = new Map();
    constructor(minIntervalMs = 10){
        this.minIntervalMs = minIntervalMs;
    }
    /**
     * Creates a filter with a minimum interval between sends.
     */ static fromMillis(minIntervalMs) {
        return new $6d4ece1462c3dd3e$export$47d2778fe368ca9f(minIntervalMs);
    }
    outbound(ctx, payload) {
        const now = Date.now();
        const key = $6d4ece1462c3dd3e$var$routeKey(ctx);
        const entry = this.entries.get(key) ?? {};
        this.entries.set(key, entry);
        if ($6d4ece1462c3dd3e$var$canSendNow(entry.lastSent, now, this.minIntervalMs)) {
            entry.lastSent = now;
            delete entry.pending;
            return [
                payload
            ];
        }
        entry.pending = {
            tenant: ctx.tenant,
            channel: ctx.channel,
            payload: payload
        };
        return [];
    }
    onTimer(_ctx) {
        const now = Date.now();
        const messages = [];
        for (const entry of this.entries.values()){
            if (!entry.pending || !$6d4ece1462c3dd3e$var$canSendNow(entry.lastSent, now, this.minIntervalMs)) continue;
            messages.push(entry.pending);
            delete entry.pending;
            entry.lastSent = now;
        }
        return messages;
    }
}
function $6d4ece1462c3dd3e$var$canSendNow(lastSent, now, minIntervalMs) {
    return lastSent === undefined || now - lastSent >= minIntervalMs;
}
function $6d4ece1462c3dd3e$var$routeKey(ctx) {
    return `${ctx.tenant}:${ctx.channel}`;
}


/** Восстановление overlay-сессии: новый AT с demo-server, без soft refresh. */ /** Минимум между запросами нового AT (анти-шторм). */ const $73a28c5fd524ace0$export$de2ecef903caff08 = 20000;
const $73a28c5fd524ace0$export$6644b2b69bf23822 = 5;
function $73a28c5fd524ace0$export$f73299ed082a9c6a(pingIntervalSec, missLimit = $73a28c5fd524ace0$export$6644b2b69bf23822) {
    return Math.max(3000, pingIntervalSec * 1000 * missLimit);
}
function $73a28c5fd524ace0$export$138014f51fb5e53a(options = {}) {
    const pingIntervalSec = options.pingIntervalSec ?? 3;
    const missLimit = options.missLimit ?? $73a28c5fd524ace0$export$6644b2b69bf23822;
    const staleMs = $73a28c5fd524ace0$export$f73299ed082a9c6a(pingIntervalSec, missLimit);
    let lastPongAtMs = 0;
    return {
        /** Отметить успешный PONG (событие SDK `rttMeasured`). */ notePong (nowMs = Date.now()) {
            lastPongAtMs = nowMs;
        },
        /** Старт/grace после connect или reissue — ждём первый PONG. */ noteConnected (nowMs = Date.now()) {
            lastPongAtMs = nowMs;
        },
        /** @returns {boolean} */ isStale (nowMs = Date.now()) {
            if (!lastPongAtMs) return false;
            return nowMs - lastPongAtMs >= staleMs;
        },
        /** @returns {number} секунд без PONG */ staleSec (nowMs = Date.now()) {
            if (!lastPongAtMs) return 0;
            return Math.max(0, Math.floor((nowMs - lastPongAtMs) / 1000));
        }
    };
}
function $73a28c5fd524ace0$export$c75a89679e292f76(event) {
    if (event.type !== "error" || !event.error) return false;
    const kind = event.error.type;
    // reconnect: WS не поднялся со старым AT; server: perimeter прислал ERR:
    return kind === "reconnect" || kind === "server";
}
function $73a28c5fd524ace0$export$17ef96d70f341212(cooldownMs = $73a28c5fd524ace0$export$de2ecef903caff08) {
    let inFlight = false;
    let lastAtMs = 0;
    return {
        /** @returns {boolean} */ tryBegin () {
            if (inFlight) return false;
            const now = Date.now();
            if (now - lastAtMs < cooldownMs) return false;
            inFlight = true;
            lastAtMs = now;
            return true;
        },
        end () {
            inFlight = false;
        }
    };
}


/** WS PING interval for link quality (seconds). */ const $4a68f02554b6f92a$export$3ddc3df169b908 = 3;
const $4a68f02554b6f92a$export$35c5df7872f016f3 = 3000;
function $4a68f02554b6f92a$export$b27848052134e8d9(builder) {
    return builder.pingIntervalSec($4a68f02554b6f92a$export$3ddc3df169b908);
}
function $4a68f02554b6f92a$export$22b6e3e09e7618e1(snapshot) {
    const last = snapshot?.lastRttMs;
    const median = snapshot?.medianRttMs;
    if (last == null && median == null) return "ws rtt \u2026";
    const parts = [];
    if (last != null) parts.push(`last ${last} ms`);
    if (median != null) parts.push(`median ${median} ms`);
    return `ws ${parts.join(", ")}`;
}
function $4a68f02554b6f92a$export$9da51ec074aeac90(client) {
    if (!client || typeof client.linkQuality !== "function") return {
        lastRttMs: undefined,
        medianRttMs: undefined
    };
    return client.linkQuality(30);
}
function $4a68f02554b6f92a$export$f16c22ed31b708df(client, onSnapshot, intervalMs = $4a68f02554b6f92a$export$35c5df7872f016f3) {
    const tick = ()=>onSnapshot($4a68f02554b6f92a$export$9da51ec074aeac90(client));
    tick();
    return window.setInterval(tick, intervalMs);
}


/** Preset palette colors (hex). */ const $163d3d74b44519b0$var$PRESET_COLORS = [
    "#ff4466",
    "#ff8844",
    "#ffcc00",
    "#44cc66",
    "#44aaff",
    "#aa66ff",
    "#ffffff",
    "#888888"
];
/** Default brush size for old messages without byte 7. */ const $163d3d74b44519b0$var$DEFAULT_BRUSH_SIZE = 4;
/** Incoming message counter for the status bar. */ let $163d3d74b44519b0$var$recvCount = 0;
let $163d3d74b44519b0$var$sendCount = 0;
/** Current color in RGB565. */ let $163d3d74b44519b0$var$selectedColor = $163d3d74b44519b0$var$hexToRgb565("#ff4466");
/** Brush size in pixels. */ let $163d3d74b44519b0$var$brushSize = $163d3d74b44519b0$var$DEFAULT_BRUSH_SIZE;
/** SendRateFilter rate: 0 = no limit. */ let $163d3d74b44519b0$var$sendRateHz = 60;
/** Paint area size (width/height, updated on resize). */ let $163d3d74b44519b0$var$paintSize = {
    width: 1,
    height: 1
};
/** SDK session with chosen edge (client-side bootstrap). */ let $163d3d74b44519b0$var$fpsSession = null;
/** SDK client handle for reconnect on rate change. */ let $163d3d74b44519b0$var$client = null;
let $163d3d74b44519b0$var$messagesQueue = null;
let $163d3d74b44519b0$var$recvLoopGeneration = 0;
/** Demo config and AT after connect. */ let $163d3d74b44519b0$var$demoConfig = null;
let $163d3d74b44519b0$var$accessToken = null;
let $163d3d74b44519b0$var$selectedEdgeApiBase = "";
let $163d3d74b44519b0$var$selectedEdgeLabel = "";
let $163d3d74b44519b0$var$linkQualityLabel = "ws rtt \u2026";
let $163d3d74b44519b0$var$linkQualityTimer = null;
/** Один reissue за раз + cooldown. */ const $163d3d74b44519b0$var$overlayReissue = (0, $73a28c5fd524ace0$export$17ef96d70f341212)();
/** Живость overlay по SDK PING/PONG. */ const $163d3d74b44519b0$var$overlayPing = (0, $73a28c5fd524ace0$export$138014f51fb5e53a)({
    pingIntervalSec: (0, $4a68f02554b6f92a$export$3ddc3df169b908)
});
const $163d3d74b44519b0$var$statusEl = document.getElementById("status");
const $163d3d74b44519b0$var$canvas = document.getElementById("canvas");
const $163d3d74b44519b0$var$paintArea = document.getElementById("paint-area");
const $163d3d74b44519b0$var$paletteEl = document.getElementById("palette");
const $163d3d74b44519b0$var$colorPicker = document.getElementById("color-picker");
const $163d3d74b44519b0$var$clearSelect = document.getElementById("clear-interval");
const $163d3d74b44519b0$var$ctx = $163d3d74b44519b0$var$canvas.getContext("2d");
/** Starts demo: bootstrap, token, WebSocket, subscribe. */ async function $163d3d74b44519b0$var$main() {
    $163d3d74b44519b0$var$setupPalette();
    $163d3d74b44519b0$var$setupBrushButtons();
    $163d3d74b44519b0$var$setupRateButtons();
    $163d3d74b44519b0$var$setupClearTimer();
    $163d3d74b44519b0$var$resizeCanvas();
    window.addEventListener("resize", $163d3d74b44519b0$var$resizeCanvas);
    try {
        await $163d3d74b44519b0$var$connectClient();
        $163d3d74b44519b0$var$paintArea.addEventListener("pointermove", $163d3d74b44519b0$var$onPointerMove);
        $163d3d74b44519b0$var$refreshConnectedStatus();
        $163d3d74b44519b0$var$startStatsTimer();
    } catch (error) {
        console.error(error);
        $163d3d74b44519b0$var$setStatus(`error: ${error.message}`, false);
    }
}
/**
 * Full FastPubSub client flow:
 * config -> bootstrap/resolveEdge -> AT from demo-server -> WebSocket.
 */ async function $163d3d74b44519b0$var$connectClient() {
    $163d3d74b44519b0$var$demoConfig = await $163d3d74b44519b0$var$fetchDemoConfig();
    $163d3d74b44519b0$var$setStatus("bootstrap: picking nearest edge...", true);
    $163d3d74b44519b0$var$fpsSession = (0, $20120b594434c913$export$3ce6949f20cea765)($163d3d74b44519b0$var$demoConfig.overlay);
    const edge = await $163d3d74b44519b0$var$fpsSession.resolveEdge({
        cache: "prefer"
    });
    $163d3d74b44519b0$var$selectedEdgeLabel = `${edge.candidate.id} (${Math.round(edge.pingMs)} ms)`;
    console.log("selected edge", edge.candidate.id, edge.candidate.apiBase, Math.round(edge.pingMs));
    $163d3d74b44519b0$var$setStatus(`bootstrap: requesting AT for ${edge.candidate.id}...`, true);
    $163d3d74b44519b0$var$selectedEdgeApiBase = edge.candidate.apiBase;
    const tokenResponse = await $163d3d74b44519b0$var$fetchToken(edge.candidate.apiBase);
    $163d3d74b44519b0$var$accessToken = tokenResponse.token;
    $163d3d74b44519b0$var$client = await $163d3d74b44519b0$var$buildClient($163d3d74b44519b0$var$fpsSession, $163d3d74b44519b0$var$accessToken);
    $163d3d74b44519b0$var$messagesQueue = await $163d3d74b44519b0$var$client.subscribe($163d3d74b44519b0$var$demoConfig.tenant, $163d3d74b44519b0$var$demoConfig.channel);
    $163d3d74b44519b0$var$startReceiveLoop();
    $163d3d74b44519b0$var$restartLinkQualityTimer();
}
/** GET /api/v1/demo/desktop/config */ async function $163d3d74b44519b0$var$fetchDemoConfig() {
    const response = await fetch("/api/v1/demo/desktop/config");
    if (!response.ok) throw new Error(`config API ${response.status}`);
    return response.json();
}
/** POST /api/v1/demo/desktop/token — AT for selected edge api_base. */ async function $163d3d74b44519b0$var$fetchToken(apiBase) {
    const response = await fetch("/api/v1/demo/desktop/token", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            api_base: apiBase
        })
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(`token API ${response.status}: ${text}`);
    }
    return response.json();
}
/**
 * Overlay не работает с текущим AT → новый AT с demo-server + новый WS.
 * @param {string} reason
 */ async function $163d3d74b44519b0$var$reissueOverlaySession(reason) {
    if (!$163d3d74b44519b0$var$overlayReissue.tryBegin() || !$163d3d74b44519b0$var$fpsSession || !$163d3d74b44519b0$var$selectedEdgeApiBase || !$163d3d74b44519b0$var$demoConfig) return;
    console.warn(`[desktop] \u{43D}\u{43E}\u{432}\u{44B}\u{439} AT: ${reason}`);
    $163d3d74b44519b0$var$setStatus("token reissue...", true);
    try {
        const tokenResponse = await $163d3d74b44519b0$var$fetchToken($163d3d74b44519b0$var$selectedEdgeApiBase);
        $163d3d74b44519b0$var$accessToken = tokenResponse.token;
        $163d3d74b44519b0$var$recvLoopGeneration += 1;
        const oldClient = $163d3d74b44519b0$var$client;
        $163d3d74b44519b0$var$client = null;
        $163d3d74b44519b0$var$messagesQueue = null;
        try {
            oldClient?.close();
        } catch (closeError) {
            console.warn("[desktop] close old client", closeError);
        }
        $163d3d74b44519b0$var$client = await $163d3d74b44519b0$var$buildClient($163d3d74b44519b0$var$fpsSession, $163d3d74b44519b0$var$accessToken);
        $163d3d74b44519b0$var$messagesQueue = await $163d3d74b44519b0$var$client.subscribe($163d3d74b44519b0$var$demoConfig.tenant, $163d3d74b44519b0$var$demoConfig.channel);
        $163d3d74b44519b0$var$startReceiveLoop();
        $163d3d74b44519b0$var$restartLinkQualityTimer();
        $163d3d74b44519b0$var$refreshConnectedStatus();
    } catch (reissueError) {
        $163d3d74b44519b0$var$setStatus(`error: ${reissueError.message || reason}`, false);
    } finally{
        $163d3d74b44519b0$var$overlayReissue.end();
    }
}
/** SDK: отказ overlay или нет PONG → новый AT. */ function $163d3d74b44519b0$var$handleWebSocketEvent(event) {
    if (event.type === "rttMeasured") {
        $163d3d74b44519b0$var$overlayPing.notePong();
        return;
    }
    if (!(0, $73a28c5fd524ace0$export$c75a89679e292f76)(event)) return;
    const msg = event.error?.message || event.error?.type || "overlay";
    console.warn(`[desktop] overlay error:`, msg);
    $163d3d74b44519b0$var$reissueOverlaySession(msg);
}
/** WebSocket via session.webSocket (endpoint chosen at bootstrap). */ async function $163d3d74b44519b0$var$buildClient(session, token) {
    let builder = session.webSocket(token).filterTimerMode("lowLatency200Hz").onWebSocketEvent($163d3d74b44519b0$var$handleWebSocketEvent);
    builder = (0, $4a68f02554b6f92a$export$b27848052134e8d9)(builder);
    if ($163d3d74b44519b0$var$sendRateHz > 0) builder = builder.addFilter($163d3d74b44519b0$var$demoConfig.tenant, $163d3d74b44519b0$var$demoConfig.channel, (0, $6d4ece1462c3dd3e$export$47d2778fe368ca9f).fromMillis($163d3d74b44519b0$var$hzToIntervalMs($163d3d74b44519b0$var$sendRateHz)));
    return builder.build().then((built)=>{
        $163d3d74b44519b0$var$overlayPing.noteConnected();
        return built;
    });
}
/** Polls WS link quality every 3 seconds. */ function $163d3d74b44519b0$var$restartLinkQualityTimer() {
    if ($163d3d74b44519b0$var$linkQualityTimer !== null) {
        clearInterval($163d3d74b44519b0$var$linkQualityTimer);
        $163d3d74b44519b0$var$linkQualityTimer = null;
    }
    $163d3d74b44519b0$var$linkQualityTimer = (0, $4a68f02554b6f92a$export$f16c22ed31b708df)($163d3d74b44519b0$var$client, (snapshot)=>{
        if ($163d3d74b44519b0$var$overlayPing.isStale()) {
            $163d3d74b44519b0$var$reissueOverlaySession(`\u{43D}\u{435}\u{442} PONG ${$163d3d74b44519b0$var$overlayPing.staleSec()}s`);
            return;
        }
        $163d3d74b44519b0$var$linkQualityLabel = (0, $4a68f02554b6f92a$export$22b6e3e09e7618e1)(snapshot);
        $163d3d74b44519b0$var$refreshConnectedStatus();
    }, (0, $4a68f02554b6f92a$export$35c5df7872f016f3));
}
/** Status line for a healthy WebSocket session. */ function $163d3d74b44519b0$var$refreshConnectedStatus() {
    $163d3d74b44519b0$var$setStatus(`connected | edge ${$163d3d74b44519b0$var$selectedEdgeLabel} | ${$163d3d74b44519b0$var$linkQualityLabel} | ${$163d3d74b44519b0$var$rateLabel()}`, true);
}
/** Receive loop: draw points from messages. */ function $163d3d74b44519b0$var$startReceiveLoop() {
    const generation = ++$163d3d74b44519b0$var$recvLoopGeneration;
    (async ()=>{
        while($163d3d74b44519b0$var$messagesQueue && generation === $163d3d74b44519b0$var$recvLoopGeneration){
            const message = await $163d3d74b44519b0$var$messagesQueue.recv();
            if (!message || generation !== $163d3d74b44519b0$var$recvLoopGeneration) break;
            $163d3d74b44519b0$var$recvCount += 1;
            $163d3d74b44519b0$var$drawPointFromPayload(message.payload);
        }
    })();
}
/**
 * Pointer move: pointermove + getCoalescedEvents (for Firefox).
 * Publishes each point from the coalesced list.
 */ function $163d3d74b44519b0$var$onPointerMove(event) {
    if (!$163d3d74b44519b0$var$client || !$163d3d74b44519b0$var$demoConfig) return;
    const rect = $163d3d74b44519b0$var$paintArea.getBoundingClientRect();
    const events = event.getCoalescedEvents?.() ?? [
        event
    ];
    for (const point of events)$163d3d74b44519b0$var$publishPointAt(point.clientX, point.clientY, rect);
}
/** Publishes one point from screen coordinates. */ function $163d3d74b44519b0$var$publishPointAt(clientX, clientY, areaRect) {
    const x = clientX - areaRect.left;
    const y = clientY - areaRect.top;
    if (x < 0 || y < 0 || x > areaRect.width || y > areaRect.height) return;
    const payload = $163d3d74b44519b0$var$encodePoint(x, y, areaRect.width, areaRect.height, $163d3d74b44519b0$var$selectedColor, $163d3d74b44519b0$var$brushSize);
    $163d3d74b44519b0$var$client.publish($163d3d74b44519b0$var$demoConfig.tenant, $163d3d74b44519b0$var$demoConfig.channel, payload).then(()=>{
        $163d3d74b44519b0$var$sendCount += 1;
    }).catch((error)=>{
        console.error("publish error", error);
    });
}
/**
 * Encodes a point as 7 bytes:
 * x u16, y u16, color RGB565, brush size u8.
 */ function $163d3d74b44519b0$var$encodePoint(x, y, width, height, color, size) {
    const nx = Math.max(0, Math.min(65535, Math.round(x / width * 65535)));
    const ny = Math.max(0, Math.min(65535, Math.round(y / height * 65535)));
    const brush = Math.max(1, Math.min(255, Math.round(size)));
    const buf = new Uint8Array(7);
    const view = new DataView(buf.buffer);
    view.setUint16(0, nx, false);
    view.setUint16(2, ny, false);
    view.setUint16(4, color, false);
    view.setUint8(6, brush);
    return buf;
}
/** Decodes channel payload and draws a point on the canvas. */ function $163d3d74b44519b0$var$drawPointFromPayload(payload) {
    if (!payload || payload.length < 6) return;
    const view = new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
    const nx = view.getUint16(0, false);
    const ny = view.getUint16(2, false);
    const color = view.getUint16(4, false);
    const size = payload.length >= 7 ? view.getUint8(6) : $163d3d74b44519b0$var$DEFAULT_BRUSH_SIZE;
    const x = nx / 65535 * $163d3d74b44519b0$var$paintSize.width;
    const y = ny / 65535 * $163d3d74b44519b0$var$paintSize.height;
    $163d3d74b44519b0$var$drawBrush(x, y, $163d3d74b44519b0$var$rgb565ToCss(color), size);
}
/** Draws a brush square on the canvas. */ function $163d3d74b44519b0$var$drawBrush(x, y, cssColor, size) {
    const px = Math.max(1, Math.round(size));
    $163d3d74b44519b0$var$ctx.fillStyle = cssColor;
    $163d3d74b44519b0$var$ctx.fillRect(x, y, px, px);
}
/** Rate label for the status bar. */ function $163d3d74b44519b0$var$rateLabel() {
    if ($163d3d74b44519b0$var$sendRateHz <= 0) return "no limit";
    return `${$163d3d74b44519b0$var$sendRateHz}/s`;
}
/** Converts rate to milliseconds for SendRateFilter. */ function $163d3d74b44519b0$var$hzToIntervalMs(hz) {
    return Math.max(1, Math.round(1000 / hz));
}
/** Converts hex #rrggbb to RGB565. */ function $163d3d74b44519b0$var$hexToRgb565(hex) {
    const value = hex.replace("#", "");
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return r >> 3 << 11 | g >> 2 << 5 | b >> 3;
}
/** Converts RGB565 to a CSS color. */ function $163d3d74b44519b0$var$rgb565ToCss(rgb565) {
    const r = (rgb565 >> 11 & 0x1f) * 255 / 31;
    const g = (rgb565 >> 5 & 0x3f) * 255 / 63;
    const b = (rgb565 & 0x1f) * 255 / 31;
    return `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})`;
}
/** Fits canvas size and caches paint area coordinates. */ function $163d3d74b44519b0$var$resizeCanvas() {
    const rect = $163d3d74b44519b0$var$paintArea.getBoundingClientRect();
    $163d3d74b44519b0$var$canvas.width = Math.floor(rect.width);
    $163d3d74b44519b0$var$canvas.height = Math.floor(rect.height);
    $163d3d74b44519b0$var$paintSize = {
        width: rect.width,
        height: rect.height
    };
}
/** Builds palette color buttons. */ function $163d3d74b44519b0$var$setupPalette() {
    for (const hex of $163d3d74b44519b0$var$PRESET_COLORS){
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "swatch";
        btn.style.background = hex;
        btn.title = hex;
        if (hex === "#ff4466") btn.classList.add("active");
        btn.addEventListener("click", ()=>{
            document.querySelectorAll(".swatch").forEach((el)=>el.classList.remove("active"));
            btn.classList.add("active");
            $163d3d74b44519b0$var$selectedColor = $163d3d74b44519b0$var$hexToRgb565(hex);
            $163d3d74b44519b0$var$colorPicker.value = hex;
        });
        $163d3d74b44519b0$var$paletteEl.appendChild(btn);
    }
    $163d3d74b44519b0$var$colorPicker.addEventListener("input", ()=>{
        document.querySelectorAll(".swatch").forEach((el)=>el.classList.remove("active"));
        $163d3d74b44519b0$var$selectedColor = $163d3d74b44519b0$var$hexToRgb565($163d3d74b44519b0$var$colorPicker.value);
    });
}
/** Brush size buttons. */ function $163d3d74b44519b0$var$setupBrushButtons() {
    document.querySelectorAll("#brush-sizes .toggle-btn").forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            document.querySelectorAll("#brush-sizes .toggle-btn").forEach((el)=>el.classList.remove("active"));
            btn.classList.add("active");
            $163d3d74b44519b0$var$brushSize = Number(btn.dataset.size);
        });
    });
}
/** Rate switcher: rebuilds WebSocket with a new filter. */ function $163d3d74b44519b0$var$setupRateButtons() {
    document.querySelectorAll("#rate-buttons .toggle-btn").forEach((btn)=>{
        btn.addEventListener("click", async ()=>{
            document.querySelectorAll("#rate-buttons .toggle-btn").forEach((el)=>el.classList.remove("active"));
            btn.classList.add("active");
            $163d3d74b44519b0$var$sendRateHz = Number(btn.dataset.hz);
            if (!$163d3d74b44519b0$var$fpsSession || !$163d3d74b44519b0$var$accessToken) return;
            $163d3d74b44519b0$var$setStatus("reconnecting WebSocket...", true);
            $163d3d74b44519b0$var$recvLoopGeneration += 1;
            const oldClient = $163d3d74b44519b0$var$client;
            $163d3d74b44519b0$var$client = null;
            $163d3d74b44519b0$var$messagesQueue = null;
            oldClient.close();
            try {
                $163d3d74b44519b0$var$client = await $163d3d74b44519b0$var$buildClient($163d3d74b44519b0$var$fpsSession, $163d3d74b44519b0$var$accessToken);
                $163d3d74b44519b0$var$messagesQueue = await $163d3d74b44519b0$var$client.subscribe($163d3d74b44519b0$var$demoConfig.tenant, $163d3d74b44519b0$var$demoConfig.channel);
                $163d3d74b44519b0$var$startReceiveLoop();
                $163d3d74b44519b0$var$restartLinkQualityTimer();
                $163d3d74b44519b0$var$refreshConnectedStatus();
            } catch (error) {
                $163d3d74b44519b0$var$setStatus(`error: ${error.message}`, false);
            }
        });
    });
}
/** Local canvas clear on a timer, or off. */ function $163d3d74b44519b0$var$setupClearTimer() {
    let timerId = null;
    const restart = ()=>{
        if (timerId !== null) {
            clearInterval(timerId);
            timerId = null;
        }
        if ($163d3d74b44519b0$var$clearSelect.value === "never") return;
        const seconds = Number($163d3d74b44519b0$var$clearSelect.value);
        timerId = setInterval(()=>{
            $163d3d74b44519b0$var$ctx.clearRect(0, 0, $163d3d74b44519b0$var$canvas.width, $163d3d74b44519b0$var$canvas.height);
        }, seconds * 1000);
    };
    $163d3d74b44519b0$var$clearSelect.addEventListener("change", restart);
    restart();
}
/** Updates recv/send counters every second; link quality refreshes separately. */ function $163d3d74b44519b0$var$startStatsTimer() {
    setInterval(()=>{
        if (!$163d3d74b44519b0$var$statusEl.classList.contains("err")) {
            $163d3d74b44519b0$var$statusEl.textContent = `connected | edge ${$163d3d74b44519b0$var$selectedEdgeLabel} | ${$163d3d74b44519b0$var$linkQualityLabel} | ${$163d3d74b44519b0$var$rateLabel()} | recv ${$163d3d74b44519b0$var$recvCount}/s send ${$163d3d74b44519b0$var$sendCount}/s | brush ${$163d3d74b44519b0$var$brushSize}px`;
            $163d3d74b44519b0$var$recvCount = 0;
            $163d3d74b44519b0$var$sendCount = 0;
        }
    }, 1000);
}
/** Sets status text. */ function $163d3d74b44519b0$var$setStatus(text, ok) {
    $163d3d74b44519b0$var$statusEl.textContent = text;
    $163d3d74b44519b0$var$statusEl.classList.toggle("ok", ok);
    $163d3d74b44519b0$var$statusEl.classList.toggle("err", !ok);
}
$163d3d74b44519b0$var$main();


//# sourceMappingURL=desktop.f6633a72.js.map
